import axios from 'axios'
// import * as XLSX from 'xlsx';
import { dataProcessingMethods } from './mixins/DataProcessingMixin';
import { uiInteractionMethods } from './mixins/UIInteractionMixin';
import { exportImportMethods } from './mixins/ExportImportMixin';
// 导入表格列宽管理混入
import { tableColumnWidthMixin } from './mixins/TableColumnWidthMixin';
// 导入共享数据混入
import { sharedDataMixin } from './mixins/SharedDataMixin';
// import { getCookie } from '@/utils'


export default {
  name: 'HomePage',
  // 添加新的混入
  mixins: [
    dataProcessingMethods, 
    uiInteractionMethods, 
    exportImportMethods,
    tableColumnWidthMixin,
    sharedDataMixin  // 添加共享数据混入
  ],
  data() {
    return {
      // 用于跟踪上一行的学校和专业组信息
      previousRowInfo: null,
      maxDataYear: 0, // 最大年份，用于初始化
      modifyTableName: '原始数据', // 修改表格名称的输入框绑定
      username: '', // 用户名，用于登录
      isLoggedIn: false, // 登录状态，用于控制页面显示
      isSuperAdmin: '用户', // 需要在适当的地方设置为true
      userVipInfo: null, // 用户VIP信息，用于显示身份角标
      vipInfo: {
        is_vip: false,
        vip_expire_date: null,
        remaining_days: 0
      },  // 用于存储VIP信息
      scoreChangeInfo: {
        can_change: true,
        remaining: -1,
        limit_config: null
      },  // 分数修改限制信息
      lastRecordedScore: null, // 记录上次已记录的分数，避免重复记录
      // 智能轮询相关变量
      loginStatusInterval: null, // 轮询定时器
      userActivityTimeout: null, // 用户活动检测定时器
      isUserActive: true, // 用户是否处于活跃状态
      lastActivityTime: Date.now(), // 最后活动时间
      POLLING_INTERVAL_ACTIVE: 30000, // 活跃时轮询间隔：30秒
      POLLING_INTERVAL_IDLE: 120000, // 空闲时轮询间隔：2分钟
      IDLE_TIMEOUT: 120000, // 空闲判定时间：2分钟无操作
      columnComments: null, // 存储从后端获取的列名注释，用于表格列名显示，在formatColumnName方法中使用
      sectionsCollapsed: false, // 控制侧边栏折叠状态，在sidebarStyle计算属性中使用
      sidebarCollapsed: false, // 添加这个属性，因为在computed中使用了它
      draggedRow: null, // 当前拖拽的行数据，在拖拽相关方法handleDragStart、handleDragOver、handleDragEnd中使用
      selectedRow: null, // 当前选中的行数据，在selectItem、右键菜单相关方法和addToWishList中使用
      selectedIndex: -1, // 当前选中行在志愿表中的索引，在移动、删除等操作方法中使用
      selectedRows: [], // 用于存储选中的行
      selectedIndices: [], // 用于存储选中行的索引
      professionalRows: JSON.parse(localStorage.getItem('professionalRows') || 'null') || [
        {
          professional: '',
          tag: '',
          schoolName: '',
          schoolProvince: '',
          schoolType: '',
          professionalRemark: ''
        }
      ], // 专业筛选条件数据，在generateTableRows、removeLastRow方法和fetchCollegeAdmission中传递给后端
      filteredData: [], // 筛选结果数据，在fetchCollegeAdmission、loadMoreData、exportFilteredData等方法中使用
      wishList: [], // 志愿表数据，在添加、删除、排序、导出等操作中使用
      mockOrOfficial: '模拟填报', // 当前是模拟填报还是正式填报状态，在fetchMockOrOfficialStatus方法中设置
      isLocalDatabase: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1', // 是否为本地数据库访问
      isLoading: false, // 控制数据加载状态，在fetchCollegeAdmission等异步请求中使用
      currentPage: 1, // 当前页码，在分页加载数据时使用
      pageSizeOptions: [1, 5, 10, 20], // 每页显示条数选项，在页面选择器中使用
      pageSize: 1, // 当前每页显示条数，在分页请求中使用
      isLoadingMore: false, // 控制是否正在加载更多数据，在loadMoreData方法中使用
      hasMoreData: true, // 标识是否还有更多数据可加载，在loadMoreData方法中根据后端返回设置
      expandedCell: null, // 当前展开的单元格，在双击显示全部内容相关方法中使用
      _lastFilterSnapshot: null, // 上次筛选条件快照，用于判断筛选条件是否改变
      tableWidthSettings: {}, // 表格列宽设置，在保存和加载列宽相关方法中使用
      schoolCount: 0,  // 添加schoolCount变量，学校的数量，初始值为0
      allSchools: [], // 存储所有学校的数组
      // 添加搜索相关的属性
      lastSearchValue: '', // 上一次搜索的值
      isScrolling: false,
      scrollTimeout: null,
      throttledLoadMore: null,
      startTime: null,
      endTime: null,
      majorGroupMap: new Map(), // 用于跟踪专业组的映射
      searchSchool: '', // 添加搜索学校的输入框绑定
      searchMajor: '',  // 新增字段，用于搜索专业
      searchTargetTable: 'filtered', // 搜索目标表格：'filtered'为筛选表，'wish'为志愿表
      currentSearchIndex: -1, // 当前搜索结果的索引位置
      searchResults: [],      // 存储所有匹配的搜索结果索引
      dataName: '', // 存储前一年的录取数据
      // 长按菜单相关
      contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextMenuRow: null,
      contextMenuRowIndex: -1,
      longPressTimer: null,
      touchStartTime: 0,
      enrollmentTypeOptionsFromAPI: [], // 从API获取的招生类型选项

      pagination: {
        currentPage: 1,
        pageSize: 1, // 默认每页1条
        pageSizes: [1, 5, 10, 20],
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      jumpPage: 1, // 跳转页码输入值
      showImportDialog: false, // 控制导入志愿表弹窗显示
      importMode: 'append', // 导入模式：append=添加，overwrite=覆盖

      formData: {
        origin: localStorage.getItem('student_origin') || '江苏',
        admit_year: 0,
        student_name: localStorage.getItem('student_name') || 'XXX',
        gender: localStorage.getItem('student_gender') || '男',
        scr_line: localStorage.getItem('student_score') ? Number(localStorage.getItem('student_score')) : 600,
        admission_rank: localStorage.getItem('student_rank') ? Number(localStorage.getItem('student_rank')) : null,
        batch: localStorage.getItem('student_batch') || '本科批',
        enrollment_type: '', // 默认空 = 全选（所有招生类型，后端不过滤）
        same_rank_score: localStorage.getItem('same_rank_score') ? Number(localStorage.getItem('same_rank_score')) : null,
        subject1: localStorage.getItem('student_subject1') || '物理',
        subject2: localStorage.getItem('student_subject2') || '化学',
        subject3: localStorage.getItem('student_subject3') || '生物',
        rush_rank: 0.2,
        stable_rank: 0.2,
        safe_rank: 1,

        expandedCell: null
      },
      // 问题反馈弹窗
      showFeedbackModal: false,
      feedbackContent: '',
      feedbackContact: '',
      isSubmittingFeedback: false,
      feedbackImages: [],  // 反馈图片列表
      previewImageUrl: null,  // 预览图片URL
      
      // 专业关联
      showMajorMappingDialog: false,  // 专业关联弹窗
      consecutiveMajorGroups: [],  // 连续相同专业分组数据
      majorMappingContextMenuVisible: false,  // 专业关联右键菜单可见性
      majorMappingContextMenuX: 0,  // 专业关联右键菜单X坐标
      majorMappingContextMenuY: 0,  // 专业关联右键菜单Y坐标
      majorMappingSelectedRecord: null,  // 专业关联右键选中的记录
      majorMappingSelectedText: '',  // 专业关联右键选中的文本
      // 志愿表详情右键菜单
      wishDetailContextMenuVisible: false,
      wishDetailContextMenuX: 0,
      wishDetailContextMenuY: 0,
      wishDetailContextMenuGroup: null,  // 右键选中的大组
      wishDetailSelectedGroups: [],  // 部分排序选中的大组 key 列表
      majorMappingCurrentPage: 1,  // 专业关联分页当前页
      majorMappingPageSize: 10,  // 专业关联分页每页条数
      highlightedRecordKey: null,  // 高亮的记录键
      majorMappingLoadingProgress: 0,  // 专业关联加载进度(0-100)
      majorMappingLoadingStatus: '',  // 专业关联加载状态文本
      isAutoMatching: false,  // 是否正在自动匹配
      autoMatchSummary: { total: 0, confirmed: 0, review: 0 },  // 自动匹配统计
      // 专业关联筛选条件
      majorMappingFilters: {
        batch: '',  // 批次筛选
        subject: '',  // 科类筛选
        origin: ''  // 生源地筛选
      },
      
      // 定位功能记录上次位置
      lastUnconfirmedIndex: -1,  // 上次定位的未确认组索引
      lastIncompleteIndex: -1,  // 上次定位的备注不全组索引
      
      // 消息通知
      showMessageModal: false,
      messageList: [],
      unreadMessageCount: 0,
      messagePollingInterval: null,  // 消息轮询定时器
      
      // 志愿表保存
      showSaveWishlistDialog: false,  // 保存志愿表弹窗
      showWishlistHistoryDialog: false,  // 志愿表历史弹窗
      showWishlistDetailDialog: false,  // 志愿表详情弹窗
      isSavingWishlist: false,  // 是否正在保存
      wishlistForm: {
        name: '',
        student_name: '',
        remark: ''
      },  // 保存志愿表表单
      wishlistHistory: [],  // 志愿表历史记录
      wishlistDetail: null,  // 志愿表详情
      wishDetailDragType: null,  // 详情拖拽类型: 'major'(专业内部) | 'group'(小组) | 'school'(大组)
      wishDetailDragGroup: null,  // 被拖拽的小组对象
      wishDetailDragSchool: null,  // 被拖拽的学校名
      wishDetailDragGroupKey: null,  // 被拖拽专业所在的组key（用于专业内部拖动）
      wishDetailDragMajorIdx: null,  // 被拖拽专业在组内的索引
      wishDetailDropKey: null,  // 当前悬停的目标组key（用于高亮）
      wishDetailMovedKeys: [],  // 移动成功后被移动的组key列表（用于高亮）
      wishDetailMovedMajorKey: null,  // 专业移动成功后被移动的行 { groupKey, majorIdx }
      wishDetailRemovedEmpties: [],  // 已删除空行的大组key列表
      // 志愿表分享
      wishlistTab: 'my',  // 选项卡: 'my' | 'shared-to-me'
      showShareDialog: false,  // 分享对话框
      shareTargetWishlist: null,  // 当前要分享的志愿表
      shareTargetPhone: '',  // 被分享者手机号
      sharePermission: 'view',  // 权限: 'view' | 'edit'
      shareErrorMessage: '',  // 分享错误提示
      isSharing: false,  // 是否正在分享
      sharedWishlists: [],  // 分享给我的记录
      sharedWishlistsLoaded: false,  // 分享记录是否已加载
      showWishlistGuide: false,  // 志愿记录引导提示显示状态
      pdfMarginMode: 'narrow',  // PDF导出边距模式，默认窄边距
      // 列筛选相关
      showColumnSearchIcons: false,  // 控制列搜索图标是否显示
      columnFilterValues: {},  // 存储每列的筛选选项数组 { columnKey: ['val1', 'val2'] }
      showColumnFilter: {},  // 控制每列筛选弹窗的显示 { columnKey: true/false }
      columnFilterSearchText: {},  // 列筛选弹窗内的搜索框文本 { columnKey: 'searchText' }
      displayFilteredData: [],  // 列筛选后的显示数据（手动刷新，避免每次勾选都计算）
      columnUniqueCache: {},  // 列唯一值缓存 { key: [val1, val2, ...] }，按需懒加载
      // 志愿表列筛选相关（与筛选表一致：多选下拉列表）
      wishColumnFilterValues: {},  // 存储每列的筛选选项数组 { columnKey: ['val1', 'val2'] }
      wishShowColumnFilter: {},  // 控制每列筛选弹窗的显示
      wishColumnFilterSearchText: {},  // 列筛选弹窗内的搜索框文本
      wishColumnUniqueCache: {},  // 列唯一值缓存
      displayWishData: [],  // 列筛选后的志愿表显示数据
      // 自动排序模式：maxRank = 组间按最低位次最大排序（当前），minScoreRank = 组间按组内最低分对应位次升序
      wishSortMode: 'maxRank',
      showSortDialog: false,
    }
  },
  computed: {
    // 当前年份
    currentYear() {
      return new Date().getFullYear();
    },
    // 检查是否有规划师权限（包括管理员、超级管理员、规划师SVIP）
    hasSvipPermission() {
      // 超级管理员或管理员
      if (this.isSuperAdmin === '超级管理员' || this.isSuperAdmin === '管理员' || this.isSuperAdmin === '规划师') {
        return true;
      }
      // 通过VIP卡激活的管理员（后端已判断有效期）
      if (this.userVipInfo?.is_admin) {
        return true;
      }
      // 通过VIP卡激活的规划师SVIP（后端已判断有效期）
      if (this.userVipInfo?.is_svip) {
        return true;
      }
      return false;
    },
    // 表格列名（排除 rank_trend、grad_dir、main_sub、job_dir 内部字段）
    tableColumnKeys() {
      if (this.filteredData && this.filteredData.length > 0) {
        const hiddenCols = ['rank_trend', 'grad_dir', 'main_sub', 'job_dir'];
        return Object.keys(this.filteredData[0]).filter(k => !hiddenCols.includes(k));
      }
      return [];
    },
    // 志愿表列名（排除内部字段）
    wishListColumns() {
      if (this.wishList && this.wishList.length > 0) {
        const hiddenCols = ['rank_trend', 'grad_dir', 'main_sub', 'job_dir', 'order'];
        return Object.keys(this.wishList[0]).filter(k => !hiddenCols.includes(k));
      }
      return [];
    },
    // 列筛选后的志愿表数据
    columnFilteredWishData() {
      return this.displayWishData;
    },
    // 筛选表是否有激活的列筛选（由计算属性自动管理，依赖 columnFilterValues）
    hasActiveColumnFilters() {
      return Object.keys(this.columnFilterValues).some(key => {
        const selected = this.columnFilterValues[key];
        return selected && selected.length > 0;
      });
    },
    // 志愿表是否有激活的列筛选
    wishHasActiveColumnFilters() {
      return Object.keys(this.wishColumnFilterValues).some(key => {
        const selected = this.wishColumnFilterValues[key];
        return selected && selected.length > 0;
      });
    },
    // 志愿表详情按院校专业组分组（用于详情弹窗展示）
    wishlistDetailGrouped() {
      if (!this.wishlistDetail || !this.wishlistDetail.items || this.wishlistDetail.items.length === 0) {
        return [];
      }
      // 使用 Map 按 key 分组，保留首次出现的顺序
      const groupsMap = new Map();
      this.wishlistDetail.items.forEach((item) => {
        const schoolName = item.school_name || item.学校名称 || '';
        const majorGroup = item.major_group || item.专业组 || '';
        const groupKey = `${schoolName}_${majorGroup}`;
        if (!groupsMap.has(groupKey)) {
          const rawMinRank = item.group_actual_min_rank;
          let groupMinRank = null;
          if (rawMinRank != null && rawMinRank !== '' && rawMinRank !== undefined) {
            const cleaned = String(rawMinRank).replace(/[^\d.-]/g, '').trim();
            const num = Number(cleaned);
            if (!isNaN(num) && isFinite(num) && num > 0) {
              groupMinRank = num;
            }
          }
          groupsMap.set(groupKey, {
            key: groupKey,
            groupIndex: 0, // 稍后重新编号
            schoolName: schoolName,
            majorGroup: majorGroup,
            schoolCode: item.school_code || item.学校代码 || item.school_id || '',
            score: item.l_scr || item.最低分 || item.score || '',
            rank: item.l_rnk || item.最低位次 || item.admission_rank || '',
            risk: item.risk || item.冲稳保 || '',
            groupMinRank: groupMinRank,
            majors: [],
          });
        }
        const group = groupsMap.get(groupKey);
        group.majors.push({
          order: group.majors.length + 1,
          majorCode: item.major_code || item.专业代码 || '',
          majorName: item.major_name || item.专业名称 || '',
          score: item.l_scr || item.最低分 || item.score || '',
          rank: item.l_rnk || item.最低位次 || item.admission_rank || '',
          risk: item.risk || item.冲稳保 || '',
          rnk_gas: item.rnk_gas != null ? item.rnk_gas : null,
          scale_change: item.scale_change != null ? item.scale_change : null,
        });
      });
      // Map 转为数组，按 wishSortMode 决定排序方式
      const groups = Array.from(groupsMap.values());
      const sortMode = this.wishSortMode || 'maxRank';
      if (sortMode === 'minScoreRank') {
        // 先统一计算每组的 maxRank（作为备选排序依据）
        groups.forEach((g) => {
          g.maxRank = g.majors.reduce((max, m) => {
            const r = Number(m.rank);
            return !isNaN(r) && r > max ? r : max;
          }, -1);
        });
        // 方式2：按后端返回的组内最低位次（groupMinRank）升序；无效时用 maxRank 备选
        groups.sort((a, b) => {
          const aHas = a.groupMinRank != null && a.groupMinRank > 0;
          const bHas = b.groupMinRank != null && b.groupMinRank > 0;
          if (aHas && bHas) return a.groupMinRank - b.groupMinRank;
          if (aHas && !bHas) return -1;
          if (!aHas && bHas) return 1;
          // 两者都没有有效 groupMinRank，用 maxRank 备选
          if (a.maxRank === -1 && b.maxRank === -1) return 0;
          if (a.maxRank === -1) return 1;
          if (b.maxRank === -1) return -1;
          return a.maxRank - b.maxRank;
        });
      } else {
        // 方式1（默认）：按组内各专业位次的最大值升序
        groups.forEach((g) => {
          g.maxRank = g.majors.reduce((max, m) => {
            const r = Number(m.rank);
            return !isNaN(r) && r > max ? r : max;
          }, -1);
        });
        groups.sort((a, b) => {
          if (a.maxRank === -1 && b.maxRank === -1) return 0;
          if (a.maxRank === -1) return 1;
          if (b.maxRank === -1) return -1;
          return a.maxRank - b.maxRank;
        });
      }
      // 重新编号
      groups.forEach((g, i) => {
        g.groupIndex = i + 1;
      });
      // 每组固定填充到6个专业位，不足的补充空行
      groups.forEach((g) => {
        while (g.majors.length < 6) {
          g.majors.push({
            order: g.majors.length + 1,
            isPlaceholder: true,
            majorCode: '',
            majorName: '',
            score: '',
            rank: '',
            risk: '',
          });
        }
      });
      return groups;
    },

    // 添加计算属性处理显示数据
    displayData() {
      // 只处理必要字段，减少不必要的计算和渲染
      return this.filteredData.map(item => {
        const simplifiedItem = {};
        // 只保留需要在表格中显示的字段
        Object.keys(this.filteredData[0] || {}).forEach(key => {
          // 对长文本进行截断
          if (typeof item[key] === 'string' && item[key].length > 50) {
            simplifiedItem[key] = item[key].substring(0, 50) + '...';
          } else {
            simplifiedItem[key] = item[key];
          }
        });
        return simplifiedItem;
      });
    },
    sidebarStyle() {
      return {
        overflow: 'hidden',
        height: this.sidebarCollapsed ? '0px' : 'auto',
        transition: 'height 0.3s ease-out'
      }
    },
    professionalData() {
      return this.professionalRows
    },
    // 根据填报类型动态生成招生类型选项
    enrollmentTypeOptions() {
      const batch = this.formData.batch;
      
      // 如果已从API获取数据，优先使用API数据
      if (this.enrollmentTypeOptionsFromAPI && this.enrollmentTypeOptionsFromAPI.length > 0) {
        // 根据批次筛选
        if (batch === '本科提前批' || batch === '专科提前批') {
          // 提前批过滤掉"普通院校"
          return this.enrollmentTypeOptionsFromAPI.filter(item => item.value !== '普通院校');
        } else if (batch === '本科批') {
          // 本科批只显示"普通院校"
          return this.enrollmentTypeOptionsFromAPI.filter(item => item.value === '普通院校');
        }
        return this.enrollmentTypeOptionsFromAPI;
      }
      
      // 默认硬编码选项（API获取失败时使用）
      if (batch === '本科提前批' || batch === '专科提前批') {
        return [
          { value: '军队院校', label: '军队院校' },
          { value: '公安政法院校', label: '公安政法院校' },
          { value: '地方农村专项', label: '地方农村专项' },
          { value: '乡村教师', label: '乡村教师' },
          { value: '农村订单定向医学生', label: '农村订单定向医学生' },
          { value: '其他院校', label: '其他院校' },
          { value: '航海院校', label: '航海院校' },
          { value: '综合评价', label: '综合评价' }
        ];
      } else if (batch === '本科批') {
        return [
          { value: '普通院校', label: '普通院校' }
        ];
      }
      // 默认显示全部选项
      return [
        { value: '', label: '全部' },
        { value: '军队院校', label: '军队院校' },
        { value: '公安政法院校', label: '公安政法院校' },
        { value: '地方农村专项', label: '地方农村专项' },
        { value: '乡村教师', label: '乡村教师' },
        { value: '农村订单定向医学生', label: '农村订单定向医学生' },
        { value: '其他院校', label: '其他院校' },
        { value: '航海院校', label: '航海院校' },
        { value: '综合评价', label: '综合评价' },
        { value: '普通院校', label: '普通院校' }
      ];
    },
    
    // 控制招生类型标签显示/隐藏（只有提前批才显示）
    showEnrollmentType() {
      const batch = this.formData.batch;
      return batch === '本科提前批' || batch === '专科提前批';
    },
    // 专业关联弹窗分页 - 总页数
    majorMappingTotalPages() {
      return Math.ceil(this.consecutiveMajorGroups.length / this.majorMappingPageSize) || 1;
    },
    // 专业关联弹窗分页 - 当前页数据
    paginatedMajorGroups() {
      const start = (this.majorMappingCurrentPage - 1) * this.majorMappingPageSize;
      const end = start + this.majorMappingPageSize;
      return this.consecutiveMajorGroups.slice(start, end);
    },
    // 专业关联筛选后的数据
    filteredMajorGroups() {
      return this.consecutiveMajorGroups.filter(group => {
        // 批次筛选
        if (this.majorMappingFilters.batch && group.batch !== this.majorMappingFilters.batch) {
          return false;
        }
        // 科类筛选
        if (this.majorMappingFilters.subject && group.subject !== this.majorMappingFilters.subject) {
          return false;
        }
        // 生源地筛选
        if (this.majorMappingFilters.origin && group.origin !== this.majorMappingFilters.origin) {
          return false;
        }
        return true;
      });
    },
    // 专业关联筛选后分页 - 总页数
    majorMappingFilteredTotalPages() {
      return Math.ceil(this.filteredMajorGroups.length / this.majorMappingPageSize) || 1;
    },
    // 专业关联筛选后分页 - 当前页数据
    paginatedFilteredMajorGroups() {
      const start = (this.majorMappingCurrentPage - 1) * this.majorMappingPageSize;
      const end = start + this.majorMappingPageSize;
      return this.filteredMajorGroups.slice(start, end);
    },
    // 分页总页数
    totalPages() {
      return Math.ceil(this.schoolCount / this.pagination.pageSize) || 1;
    },
    // 显示的页码列表
    displayedPages() {
      const current = this.pagination.currentPage;
      const total = this.totalPages;
      const pages = [];
      
      if (total <= 7) {
        // 总页数小于等于7，显示所有页码
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // 总页数大于7，显示部分页码
        if (current <= 4) {
          // 当前页在前半部分
          for (let i = 1; i <= 6; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          // 当前页在后半部分
          pages.push(1);
          pages.push('...');
          for (let i = total - 5; i <= total; i++) {
            pages.push(i);
          }
        } else {
          // 当前页在中间
          pages.push(1);
          pages.push('...');
          for (let i = current - 2; i <= current + 2; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }
      return pages;
    },
    // 志愿表详情显示数据（根据 wishDetailRemovedEmpties 过滤占位空行）
    wishlistDetailDisplayGrouped() {
      const groups = this.wishlistDetailGrouped;
      const removedSet = new Set(this.wishDetailRemovedEmpties || []);
      if (removedSet.size === 0) return groups;
      return groups.map(g => {
        if (removedSet.has(g.key)) {
          const realMajors = g.majors.filter(m => !m.isPlaceholder);
          return { ...g, majors: realMajors };
        }
        return g;
      });
    },
  },
  // 修复 getColumnComments 调用
  async created() {
    try {
      // 检查登录状态
      this.checkLoginStatus();
      
      // 获取列名注释
      const response = await axios.get('api/get_column_comments/', { withCredentials: true });
      this.columnComments = response.data;
      
      // 初始化表格宽度设置，从localStorage加载
      this.loadColumnWidths();
      
      // 初始化招生类型默认值
      // 如果localStorage没有值，会在fetchEnrollmentTypes中设置默认值
      if (!this.formData.enrollment_type) {
        this.fetchEnrollmentTypes();
      }
      
      // 在组件创建时立即调用获取位次数据的函数
      if (this.fetchRankData) {
        setTimeout(() => {
        this.fetchRankData();
      }, 5000);}

    } catch (error) {
      console.error('获取列名注释失败:', error);
      this.columnComments = {};
    }
  },
  mounted() {
    console.log('HomePage mounted 开始')
    // 设置定期保存或监听数据变化自动保存
    this.setupAutoSave();

    // 启动消息轮询
    if (this.isLoggedIn) {
      this.startMessagePolling();
      // 加载用户VIP信息
      this.loadVipInfo();
    }

     // 调用API获取原始数据中的年份最大值
     if (this.fetchMaxDataYear) {
      this.fetchMaxDataYear().then(() => {
        console.log('fetchMaxDataYear 完成')
        // 初始化 lastRecordedScore，确保在分数加载后设置
        this.$nextTick(() => {
          if (this.formData && this.formData.scr_line) {
            this.lastRecordedScore = parseInt(this.formData.scr_line, 10);
            // console.log('初始化 lastRecordedScore:', this.lastRecordedScore);
          }
        });
        // 检查是否从院校库跳转过来（确保在年份设置完成后执行）
        this.checkAndSearchFromSchool();
      }).catch(err => {
        console.error('fetchMaxDataYear 失败:', err)
        // 即使失败也要检查院校库跳转
        this.checkAndSearchFromSchool();
      });
    } else {
      // 如果没有 fetchMaxDataYear 方法，直接检查院校库跳转
      this.checkAndSearchFromSchool();
    }
  
    // 设置滚动监听器
    if (this.setupScrollListener) {
      this.setupScrollListener();
    }
    
    // 获取模拟/正式填报状态
    if (this.fetchMockOrOfficialStatus) {
      this.fetchMockOrOfficialStatus();
    }
    this.$nextTick(() => {
      this.setHeaderStyles();
      // 初始化行背景色
      if (this.updateRowBackgrounds) {
        this.updateRowBackgrounds()
      }
    });
    // 检查登录状态
    this.checkLoginStatus();
    // 加载分数修改限制信息
    this.loadScoreChangeLimitInfo();
    // 加载招生类型选项
    this.fetchEnrollmentTypes();

    // 启动登录状态智能轮询（用于检测异地登录被踢出）
    this.startLoginStatusPolling();
    // 添加页面点击事件监听器（用于隐藏右键菜单）
    document.addEventListener('click', this.handlePageClick);

    // 检查是否从Dashboard跳转过来查看志愿记录
    this.checkAndOpenWishlistHistory();
  },
  beforeDestroy() {
    // 组件销毁时停止轮询和用户活动监听
    this.stopLoginStatusPolling();
    // 停止消息轮询
    this.stopMessagePolling();
    // 移除页面点击事件监听器
    document.removeEventListener('click', this.handlePageClick);
  },
  methods: {
    // ========== 列筛选相关方法 ==========
    // 通用列值匹配：自动识别数字比较/文本包含
    matchColumnFilter(value, filterText) {
      if (value === null || value === undefined) return false;
      const text = filterText.trim();
      if (!text) return true;
      // 检查是否为数字比较语法：>=N, <=N, >N, <N, =N, !=N, N（纯数字精确匹配）
      const numMatch = text.match(/^(>=|<=|!=|>|<|=)?\s*([+-]?\d+(?:\.\d+)?)\s*$/);
      if (numMatch) {
        const operator = numMatch[1] || '=';
        const filterNum = parseFloat(numMatch[2]);
        const valNum = parseFloat(value);
        if (isNaN(valNum) || isNaN(filterNum)) return false;
        switch (operator) {
          case '>=': return valNum >= filterNum;
          case '<=': return valNum <= filterNum;
          case '>':  return valNum > filterNum;
          case '<':  return valNum < filterNum;
          case '!=': return valNum !== filterNum;
          case '=':
          default:   return valNum === filterNum;
        }
      }
      // 默认：模糊文本匹配
      return String(value).toLowerCase().includes(text.toLowerCase());
    },
    // 切换列筛选弹窗
    toggleColumnFilter(key) {
      this.$set(this.showColumnFilter, key, !this.showColumnFilter[key]);
      if (this.showColumnFilter[key]) {
        // 弹窗打开时，如果尚未选择任何选项，则默认全选
        const current = this.columnFilterValues[key];
        if (!current || !current.length) {
          this.$set(this.columnFilterValues, key, [...this.getColumnUniqueOptions(key)]);
        }
      } else {
        // 弹窗关闭时应用筛选并刷新表格
        this.refreshDisplayFilteredData();
      }
    },
    // 确定应用列筛选
    applyColumnFilter(key) {
      this.$set(this.showColumnFilter, key, false);
      this.refreshDisplayFilteredData();
    },
    // 清除单个列的筛选
    clearColumnFilter(key) {
      this.$delete(this.columnFilterValues, key);
      this.$set(this.showColumnFilter, key, false);
      this.$set(this.columnFilterSearchText, key, '');
      this.refreshDisplayFilteredData();
    },
    // 清除所有列筛选
    clearAllColumnFilters() {
      this.columnFilterValues = {};
      this.showColumnFilter = {};
      this.columnFilterSearchText = {};
      this.refreshDisplayFilteredData();
    },

    // 刷新表格显示数据（从filteredData + columnFilterValues计算，仅手动调用避免频繁刷新）
    refreshDisplayFilteredData() {
      if (!this.filteredData || !this.filteredData.length) {
        this.displayFilteredData = [];
        return;
      }
      const filters = this.columnFilterValues;
      const activeKeys = Object.keys(filters).filter(k => filters[k] && filters[k].length > 0);
      if (!activeKeys.length) {
        this.displayFilteredData = this.filteredData;
        return;
      }
      this.displayFilteredData = this.filteredData.filter(row => {
        return activeKeys.every(key => {
          const selectedValues = filters[key];
          if (!selectedValues || !selectedValues.length) return true;
          const cellValue = row[key];
          if (cellValue === null || cellValue === undefined) return false;
          return selectedValues.includes(String(cellValue));
        });
      });
    },
    // 检测筛选表或志愿表是否有激活的列筛选（被计算属性调用）
    _detectActiveColumnFilters(type) {
      const filterValues = type === 'wish' ? this.wishColumnFilterValues : this.columnFilterValues;
      const getUniqueOptions = type === 'wish' ? this.getWishColumnUniqueOptions : this.getColumnUniqueOptions;
      return Object.keys(filterValues).some(key => {
        const selected = filterValues[key];
        if (!selected || !selected.length) return false;
        const total = getUniqueOptions(key);
        return selected.length < total.length;
      });
    },
    // ===== 多选列筛选方法 =====
    // 获取某列的所有选项（按需懒加载并缓存）
    getColumnUniqueOptions(key) {
      if (this.columnUniqueCache[key]) return this.columnUniqueCache[key];
      if (!this.filteredData || !this.filteredData.length) return [];
      const values = new Set();
      this.filteredData.forEach(row => {
        if (row[key] !== null && row[key] !== undefined && row[key] !== '') {
          values.add(String(row[key]));
        }
      });
      const sorted = Array.from(values).sort();
      this.$set(this.columnUniqueCache, key, sorted);
      return sorted;
    },
    // 获取搜索过滤后的选项
    getFilteredOptions(key) {
      const searchText = (this.columnFilterSearchText[key] || '').toLowerCase();
      const options = this.getColumnUniqueOptions(key);
      if (!searchText) return options;
      return options.filter(opt => opt.toLowerCase().includes(searchText));
    },
    // 判断某个选项是否已选
    isFilterOptionSelected(key, value) {
      return (this.columnFilterValues[key] || []).includes(value);
    },
    // 切换某个选项的选中状态
    toggleFilterOption(key, value) {
      const current = this.columnFilterValues[key] || [];
      if (current.includes(value)) {
        this.$set(this.columnFilterValues, key, current.filter(v => v !== value));
      } else {
        this.$set(this.columnFilterValues, key, [...current, value]);
      }
    },
    // 判断是否全选
    isAllFilterSelected(key) {
      const options = this.getColumnUniqueOptions(key);
      if (!options.length) return false;
      return options.every(opt => this.isFilterOptionSelected(key, opt));
    },
    // 全选/取消全选
    toggleSelectAllFilter(key, checked) {
      if (checked) {
        this.$set(this.columnFilterValues, key, [...this.getColumnUniqueOptions(key)]);
      } else {
        this.$set(this.columnFilterValues, key, []);
      }
    },
    // 筛选条件改变时自动重置到第一页，条件不变则保持当前页
    handleFilterSearch() {
      const currentSnapshot = JSON.stringify({
        formData: this.formData,
        professionalRows: this.professionalRows
      });
      if (currentSnapshot !== this._lastFilterSnapshot) {
        this.currentPage = 1;
        this.pagination.currentPage = 1;
        this._lastFilterSnapshot = currentSnapshot;
      }
      this.fetchCollegeAdmission();
    },
    // ========== 列筛选方法结束 ==========
    // ========== 志愿表列筛选方法（与筛选表一致：多选下拉列表） ==========
    // 切换列筛选弹窗
    toggleWishColumnFilter(key) {
      this.$set(this.wishShowColumnFilter, key, !this.wishShowColumnFilter[key]);
      if (this.wishShowColumnFilter[key]) {
        // 弹窗打开时，如果尚未选择任何选项，则默认全选
        const current = this.wishColumnFilterValues[key];
        if (!current || !current.length) {
          this.$set(this.wishColumnFilterValues, key, [...this.getWishColumnUniqueOptions(key)]);
        }
      } else {
        this.refreshDisplayWishData();
      }
    },
    // 确定应用志愿表列筛选
    applyWishColumnFilter(key) {
      this.$set(this.wishShowColumnFilter, key, false);
      this.refreshDisplayWishData();
    },
    // 清除志愿表单个列的筛选
    clearWishColumnFilter(key) {
      this.$delete(this.wishColumnFilterValues, key);
      this.$set(this.wishShowColumnFilter, key, false);
      this.$set(this.wishColumnFilterSearchText, key, '');
      this.refreshDisplayWishData();
    },
    // 清除志愿表所有列筛选
    clearAllWishColumnFilters() {
      this.wishColumnFilterValues = {};
      this.wishShowColumnFilter = {};
      this.wishColumnFilterSearchText = {};
      this.refreshDisplayWishData();
    },

    // 刷新志愿表显示数据
    refreshDisplayWishData() {
      if (!this.wishList || !this.wishList.length) {
        this.displayWishData = [];
        return;
      }
      const filters = this.wishColumnFilterValues;
      const activeKeys = Object.keys(filters).filter(k => filters[k] && filters[k].length > 0);
      if (!activeKeys.length) {
        this.displayWishData = this.wishList;
        return;
      }
      this.displayWishData = this.wishList.filter(row => {
        return activeKeys.every(key => {
          const selectedValues = filters[key];
          if (!selectedValues || !selectedValues.length) return true;
          const cellValue = row[key];
          if (cellValue === null || cellValue === undefined) return false;
          return selectedValues.includes(String(cellValue));
        });
      });
    },
    // 获取志愿表某列的所有选项
    getWishColumnUniqueOptions(key) {
      if (this.wishColumnUniqueCache[key]) return this.wishColumnUniqueCache[key];
      if (!this.wishList || !this.wishList.length) return [];
      const values = new Set();
      this.wishList.forEach(row => {
        if (row[key] !== null && row[key] !== undefined && row[key] !== '') {
          values.add(String(row[key]));
        }
      });
      const sorted = Array.from(values).sort();
      this.$set(this.wishColumnUniqueCache, key, sorted);
      return sorted;
    },
    // 获取志愿表搜索过滤后的选项
    getWishFilteredOptions(key) {
      const searchText = (this.wishColumnFilterSearchText[key] || '').toLowerCase();
      const options = this.getWishColumnUniqueOptions(key);
      if (!searchText) return options;
      return options.filter(opt => opt.toLowerCase().includes(searchText));
    },
    // 判断志愿表某个选项是否已选
    isWishFilterOptionSelected(key, value) {
      return (this.wishColumnFilterValues[key] || []).includes(value);
    },
    // 切换志愿表某个选项的选中状态
    toggleWishFilterOption(key, value) {
      const current = this.wishColumnFilterValues[key] || [];
      if (current.includes(value)) {
        this.$set(this.wishColumnFilterValues, key, current.filter(v => v !== value));
      } else {
        this.$set(this.wishColumnFilterValues, key, [...current, value]);
      }
    },
    // 判断志愿表是否全选
    isAllWishFilterSelected(key) {
      const options = this.getWishColumnUniqueOptions(key);
      if (!options.length) return false;
      return options.every(opt => this.isWishFilterOptionSelected(key, opt));
    },
    // 志愿表全选/取消全选
    toggleSelectAllWishFilter(key, checked) {
      if (checked) {
        this.$set(this.wishColumnFilterValues, key, [...this.getWishColumnUniqueOptions(key)]);
      } else {
        this.$set(this.wishColumnFilterValues, key, []);
      }
    },
    // ========== 志愿表列筛选方法结束 ==========
    // 加载用户VIP信息
    loadVipInfo() {
      axios.get('api/vip-info/', {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
        .then(response => {
          this.userVipInfo = response.data;
        })
        .catch(error => {
          console.error('加载VIP信息失败:', error);
          this.userVipInfo = null;
        });
    },

    // 提交问题反馈
    async submitFeedback() {
      if (!this.feedbackContent.trim()) {
        this.$message.error('请输入反馈内容');
        return;
      }
      
      this.isSubmittingFeedback = true;
      try {
        const response = await axios.post('api/feedback/', {
          content: this.feedbackContent,
          contact: this.feedbackContact,
          images: this.feedbackImages
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data.success) {
          this.$message.success('反馈提交成功，感谢您的建议！');
          this.showFeedbackModal = false;
          this.feedbackContent = '';
          this.feedbackContact = '';
          this.feedbackImages = [];
        } else {
          this.$message.error(response.data.error || '提交失败');
        }
      } catch (err) {
        console.error('提交反馈失败:', err);
        this.$message.error(err.response?.data?.error || '提交失败，请稍后重试');
      } finally {
        this.isSubmittingFeedback = false;
      }
    },
    
    // 关闭反馈弹窗
    closeFeedbackModal() {
      this.showFeedbackModal = false;
      this.feedbackContent = '';
      this.feedbackContact = '';
      this.feedbackImages = [];
    },
    
    // 处理反馈弹窗中的粘贴事件
    handleFeedbackPaste(event) {
      event.preventDefault();
      const items = event.clipboardData?.items;
      if (!items) return;
      
      let imageAdded = false;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf('image') !== -1) {
          // 检查是否超过最大数量
          if (this.feedbackImages.length >= 5) {
            this.$message.warning('最多只能添加5张图片');
            return;
          }
          
          const blob = item.getAsFile();
          const reader = new FileReader();
          reader.onload = (e) => {
            this.feedbackImages.push(e.target.result);
          };
          reader.readAsDataURL(blob);
          imageAdded = true;
        }
      }
      
      if (imageAdded) {
        this.$message.success('图片已粘贴');
      }
    },
    
    // 移除反馈图片
    removeFeedbackImage(index) {
      this.feedbackImages.splice(index, 1);
    },
    
    // 预览反馈图片
    previewFeedbackImage(url) {
      this.previewImageUrl = url;
    },
    
    // 聚焦图片区域
    focusImageArea() {
      this.$refs.feedbackImageArea?.focus();
      this.$message.info('请按 Ctrl+V 粘贴图片');
    },

    // 触发文件选择
    triggerFeedbackFileInput() {
      if (this.feedbackImages.length >= 5) {
        this.$message.warning('最多只能添加5张图片');
        return;
      }
      this.$refs.feedbackFileInput?.click();
    },

    // 处理文件选择
    handleFeedbackFileSelect(e) {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      const remainingSlots = 5 - this.feedbackImages.length;
      const filesToProcess = Math.min(files.length, remainingSlots);

      if (files.length > remainingSlots) {
        this.$message.warning(`最多还能添加${remainingSlots}张图片`);
      }

      for (let i = 0; i < filesToProcess; i++) {
        const file = files[i];
        if (!file.type.startsWith('image/')) {
          this.$message.warning(`${file.name} 不是图片文件，已跳过`);
          continue;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
          this.feedbackImages.push(event.target.result);
        };
        reader.readAsDataURL(file);
      }

      // 清空input，允许重复选择同一文件
      e.target.value = '';
    },

    // ========== 消息通知相关方法 ==========
    
    // 获取用户消息列表
    async loadMessages() {
      if (!this.isLoggedIn) return;
      
      try {
        const response = await axios.get('api/messages/', {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.messageList = response.data.data;
          this.unreadMessageCount = response.data.unread_count;
        }
      } catch (err) {
        console.error('获取消息失败:', err);
      }
    },
    
    // 关闭消息弹窗
    closeMessageModal() {
      this.showMessageModal = false;
    },
    
    // 阅读消息
    async readMessage(msg) {
      if (!msg.is_read) {
        try {
          await axios.post(`api/messages/${msg.id}/read/`, {}, {
            withCredentials: true
          });
          msg.is_read = true;
          this.unreadMessageCount = Math.max(0, this.unreadMessageCount - 1);
        } catch (err) {
          console.error('标记已读失败:', err);
        }
      }
    },
    
    // 标记所有消息为已读
    async markAllMessagesRead() {
      try {
        await axios.post('api/messages/read-all/', {}, {
          withCredentials: true
        });
        
        // 更新本地状态
        this.messageList.forEach(msg => {
          msg.is_read = true;
        });
        this.unreadMessageCount = 0;
        
        this.$message.success('所有消息已标记为已读');
      } catch (err) {
        console.error('标记全部已读失败:', err);
        this.$message.error('操作失败');
      }
    },
    
    // 启动消息轮询
    startMessagePolling() {
      // 如果已经在轮询中，先停止之前的
      if (this.messagePollingInterval) {
        this.stopMessagePolling();
      }
      
      // 立即加载一次
      this.loadMessages();
      
      // 每30秒轮询一次
      this.messagePollingInterval = setInterval(() => {
        this.loadMessages();
      }, 30000);
    },
    
    // 停止消息轮询
    stopMessagePolling() {
      if (this.messagePollingInterval) {
        clearInterval(this.messagePollingInterval);
        this.messagePollingInterval = null;
      }
    },

    // 获取招生类型列表
    async fetchEnrollmentTypes() {
      try {
        const response = await axios.get('/api/getEnrollmentTypes/', {
          params: {
            batch: this.formData.batch
          }
        });
        if (response.data && response.data.options) {
          this.enrollmentTypeOptionsFromAPI = response.data.options;
          // 默认全选：enrollment_type 保持为空 = 后端不过滤（即所有招生类型）
        }
      } catch (error) {
        console.error('获取招生类型失败:', error);
        // API失败时使用默认值（已在计算属性中处理）
      }
    },

    // ===== 长按菜单相关方法 =====
    // 处理表格行的触摸开始事件
    handleRowTouchStart(event, row, index) {
      this.touchStartTime = Date.now();
      this.longPressTimer = setTimeout(() => {
        // 长按触发（600ms）
        this.showContextMenu(event, row, index);
      }, 600);
    },

    // 处理表格行的触摸结束事件
    handleRowTouchEnd(event, row, index) {
      // 清除长按定时器
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }

      // 如果触摸时间短于300ms，则视为点击，执行默认选中
      const touchDuration = Date.now() - this.touchStartTime;
      if (touchDuration < 300) {
        this.selectItem(row, index);
      }
    },

    // 处理表格行的触摸移动事件
    handleRowTouchMove() {
      // 触摸移动时取消长按
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },

    // 处理右键菜单事件
    handleContextMenu(event, row, index) {
      event.preventDefault();
      this.showContextMenu(event, row, index);
    },

    // 显示上下文菜单
    showContextMenu(event, row, index) {
      this.contextMenuRow = row;
      this.contextMenuRowIndex = index;
      this.contextMenuVisible = true;

      // 计算菜单位置
      let x, y;
      if (event.touches && event.touches.length > 0) {
        // 触摸事件
        x = event.touches[0].clientX;
        y = event.touches[0].clientY;
      } else if (event.changedTouches && event.changedTouches.length > 0) {
        // 触摸结束事件
        x = event.changedTouches[0].clientX;
        y = event.changedTouches[0].clientY;
      } else {
        // 鼠标事件
        x = event.clientX;
        y = event.clientY;
      }

      // 确保菜单不会超出屏幕边界
      const menuWidth = 150;
      const menuHeight = 200;
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      if (x + menuWidth > screenWidth) {
        x = screenWidth - menuWidth - 10;
      }
      if (y + menuHeight > screenHeight) {
        y = screenHeight - menuHeight - 10;
      }

      this.contextMenuX = x;
      this.contextMenuY = y;
    },

    // 隐藏上下文菜单
    hideContextMenu() {
      this.contextMenuVisible = false;
      this.contextMenuRow = null;
      this.contextMenuRowIndex = -1;
    },

    // 上下文菜单操作
    contextMenuAction(action) {
      const row = this.contextMenuRow;
      const index = this.contextMenuRowIndex;

      if (!row || index === -1) {
        this.hideContextMenu();
        return;
      }

      switch (action) {
        case 'addToWishList':
          // 添加到志愿表
          this.addToWishList(row);
          break;
        case 'viewDetail':
          // 查看详情（双击展开）
          this.expandedCell = this.expandedCell === index ? null : index;
          break;
        case 'copy':
          // 复制学校名称
          if (row.school_name) {
            this.copyToClipboard(row.school_name);
          }
          break;
      }

      this.hideContextMenu();
    },

    // 复制到剪贴板
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success('已复制: ' + text);
      } catch (err) {
        console.error('复制失败:', err);
        // 降级方案
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success('已复制: ' + text);
        } catch (err) {
          console.error('复制失败:', err);
          this.$message.error('复制失败');
        }
        document.body.removeChild(textArea);
      }
    },

    // 点击页面其他地方隐藏菜单
    handlePageClick(event) {
      if (this.contextMenuVisible && !event.target.closest('.context-menu')) {
        this.hideContextMenu();
      }
      if (this.wishDetailContextMenuVisible && !event.target.closest('.wish-detail-context-menu')) {
        this.closeWishDetailContextMenu();
      }
    },
    
    // ===== 专业关联弹窗右键菜单相关方法 =====
    // 处理专业关联弹窗的右键菜单事件
    handleMajorMappingContextMenu(event, record) {
      event.preventDefault();
      
      // 获取选中的文本
      const selection = window.getSelection();
      const selectedText = selection ? selection.toString().trim() : '';
      
      if (!selectedText) {
        this.$message.info('请先选择要添加的文本');
        return;
      }
      
      // 保存选中的文本和记录
      this.majorMappingSelectedRecord = record;
      this.majorMappingSelectedText = selectedText;
      
      // 显示右键菜单
      this.majorMappingContextMenuVisible = true;
      
      // 计算菜单位置
      let x = event.clientX;
      let y = event.clientY;
      
      // 确保菜单不超出屏幕
      const menuWidth = 160;
      const menuHeight = 40;
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      
      if (x + menuWidth > screenWidth) {
        x = screenWidth - menuWidth - 10;
      }
      if (y + menuHeight > screenHeight) {
        y = screenHeight - menuHeight - 10;
      }
      
      this.majorMappingContextMenuX = x;
      this.majorMappingContextMenuY = y;
    },
    
    // 关闭专业关联右键菜单
    closeMajorMappingContextMenu() {
      this.majorMappingContextMenuVisible = false;
      this.majorMappingSelectedRecord = null;
      this.majorMappingSelectedText = '';
    },
    
    // ===== 志愿表详情大组选择与部分排序 =====
    toggleWishDetailGroupSelect(group) {
      const idx = this.wishDetailSelectedGroups.indexOf(group.key);
      if (idx === -1) {
        this.wishDetailSelectedGroups.push(group.key);
      } else {
        this.wishDetailSelectedGroups.splice(idx, 1);
      }
    },
    toggleAllDetailGroups() {
      if (this.wishDetailSelectedGroups.length === this.wishlistDetailGrouped.length) {
        this.wishDetailSelectedGroups = [];
      } else {
        this.wishDetailSelectedGroups = this.wishlistDetailGrouped.map(g => g.key);
      }
    },
    partialSortSelectedGroups() {
      if (this.wishDetailSelectedGroups.length === 0) {
        this.$message.warning('请先勾选要排序的大组');
        this.closeWishDetailContextMenu();
        return;
      }
      let items = this.wishlistDetail.items;
      if (!items || items.length === 0) {
        this.closeWishDetailContextMenu();
        return;
      }
      // 1. 提取当前组顺序
      const groupKeys = [];
      const seenKey = new Set();
      items.forEach(item => {
        const key = this._getItemGroupKey(item);
        if (!seenKey.has(key)) { seenKey.add(key); groupKeys.push(key); }
      });
      // 2. 取出选中的组 key
      const selectedKeys = groupKeys.filter(k => this.wishDetailSelectedGroups.includes(k));
      if (selectedKeys.length < 2) {
        this.$message.warning('请至少勾选 2 个大组进行排序');
        this.closeWishDetailContextMenu();
        return;
      }
      // 3. 计算每个选中组的最高（最差）位次
      const rankMap = {};
      items.forEach(item => {
        const key = this._getItemGroupKey(item);
        if (!this.wishDetailSelectedGroups.includes(key)) return;
        const rank = Number(item.l_rnk) || Number(item.最低位次) || Number(item.admission_rank) || 999999;
        if (rank > (rankMap[key] ?? -1)) rankMap[key] = rank;
      });
      // 4. 选中组按最高位次从小到大排序
      selectedKeys.sort((a, b) => (rankMap[a] ?? 999999) - (rankMap[b] ?? 999999));
      // 5. 获取选中组在原 groupKeys 中的位置索引
      const posMap = {}; // { selectedKey: [index1, index2, ...] }
      groupKeys.forEach((key, idx) => {
        if (this.wishDetailSelectedGroups.includes(key)) {
          if (!posMap[key]) posMap[key] = [];
          posMap[key].push(idx);
        }
      });
      // 每个选中组占据它在 groupKeys 中的第一个（同时也是唯一的）位置，排序后放回
      const sortedPositions = [];
      selectedKeys.forEach(key => {
        (posMap[key] || []).forEach(idx => sortedPositions.push({ key, idx }));
      });
      // 按位置索引排序
      sortedPositions.sort((a, b) => a.idx - b.idx);
      // 6. 构建新组顺序：选中组排序后的 key 填入原位置
      const newGroupOrder = groupKeys.slice(); // 复制一份
      sortedPositions.forEach((pos, i) => {
        newGroupOrder[pos.idx] = selectedKeys[i];
      });
      // 7. 按新组顺序重建 items
      const newItems = [];
      const usedItems = new Set();
      newGroupOrder.forEach(key => {
        items.forEach(item => {
          if (this._getItemGroupKey(item) === key && !usedItems.has(item)) {
            newItems.push(item);
            usedItems.add(item);
          }
        });
      });
      // 补遗漏
      items.forEach(item => {
        if (!usedItems.has(item)) newItems.push(item);
      });
      // 重新编号
      newItems.forEach((item, idx) => { item.order = idx + 1; });
      // 关键：用 $set 确保 Vue 2 检测到数组变化
      this.$set(this.wishlistDetail, 'items', newItems);
      this.wishDetailSelectedGroups = []; // 清空选中
      this.syncDetailOrderToWishList();
      this.closeWishDetailContextMenu();
    },
    
    // ===== 志愿表详情大组右键菜单 =====
    handleWishDetailContextMenu(event, group) {
      event.preventDefault();
      this.wishDetailContextMenuVisible = true;
      this.wishDetailContextMenuGroup = group;
      let x = event.clientX;
      let y = event.clientY;
      // 避免菜单超出视口
      const menuWidth = 120;
      const menuHeight = 80;
      if (x + menuWidth > window.innerWidth) x = window.innerWidth - menuWidth - 5;
      if (y + menuHeight > window.innerHeight) y = window.innerHeight - menuHeight - 5;
      this.wishDetailContextMenuX = x;
      this.wishDetailContextMenuY = y;
    },
    closeWishDetailContextMenu() {
      this.wishDetailContextMenuVisible = false;
      this.wishDetailContextMenuGroup = null;
    },
    // 大组置顶
    moveSchoolToTop() {
      const group = this.wishDetailContextMenuGroup;
      if (!group) return;
      const schoolName = group.schoolName;
      const schoolKeys = [];
      const seen = new Set();
      const groupKeys = [];
      const groupSeen = new Set();
      const items = this.wishlistDetail.items;
      items.forEach(item => {
        const gKey = this._getItemGroupKey(item);
        if (!groupSeen.has(gKey)) {
          groupSeen.add(gKey);
          groupKeys.push(gKey);
          const sKey = this._getItemSchoolKey(item);
          if (!seen.has(sKey)) {
            seen.add(sKey);
            schoolKeys.push(sKey);
          }
        }
      });
      const dragIdx = schoolKeys.indexOf(schoolName);
      if (dragIdx <= 0) {
        this.closeWishDetailContextMenu();
        return;
      }
      schoolKeys.splice(dragIdx, 1);
      schoolKeys.unshift(schoolName);
      this._rebuildItemsBySchoolOrder(schoolKeys, groupKeys);
      this.closeWishDetailContextMenu();
    },
    // 大组置底
    moveSchoolToBottom() {
      const group = this.wishDetailContextMenuGroup;
      if (!group) return;
      const schoolName = group.schoolName;
      const schoolKeys = [];
      const seen = new Set();
      const groupKeys = [];
      const groupSeen = new Set();
      const items = this.wishlistDetail.items;
      items.forEach(item => {
        const gKey = this._getItemGroupKey(item);
        if (!groupSeen.has(gKey)) {
          groupSeen.add(gKey);
          groupKeys.push(gKey);
          const sKey = this._getItemSchoolKey(item);
          if (!seen.has(sKey)) {
            seen.add(sKey);
            schoolKeys.push(sKey);
          }
        }
      });
      const dragIdx = schoolKeys.indexOf(schoolName);
      if (dragIdx === -1 || dragIdx === schoolKeys.length - 1) {
        this.closeWishDetailContextMenu();
        return;
      }
      schoolKeys.splice(dragIdx, 1);
      schoolKeys.push(schoolName);
      this._rebuildItemsBySchoolOrder(schoolKeys, groupKeys);
      this.closeWishDetailContextMenu();
    },
    /** 按学校顺序重建 items */
    _rebuildItemsBySchoolOrder(schoolKeys, groupKeys) {
      const items = this.wishlistDetail.items;
      // 按新学校顺序 + 原组内顺序重建 items
      const schoolGroupOrder = [];
      const sSeen = new Set();
      groupKeys.forEach(gk => {
        const sk = items.find(i => this._getItemGroupKey(i) === gk);
        const sKey = sk ? this._getItemSchoolKey(sk) : '';
        if (!sSeen.has(gk) && schoolKeys.includes(sKey)) {
          sSeen.add(gk);
          schoolGroupOrder.push(gk);
        }
      });
      const newItems = [];
      schoolKeys.forEach(sk => {
        schoolGroupOrder.forEach(gk => {
          if (gk.startsWith(sk + '_')) {
            items.forEach(item => {
              if (this._getItemGroupKey(item) === gk && !newItems.includes(item)) {
                newItems.push(item);
              }
            });
          }
        });
      });
      items.forEach(item => {
        if (!newItems.includes(item)) newItems.push(item);
      });
      newItems.forEach((item, idx) => { item.order = idx + 1; });
      this.wishlistDetail.items = newItems;
      this.syncDetailOrderToWishList();
    },
    
    // 判断一组是否全部勾选
    isGroupAllSelected(group) {
      if (!group.records || group.records.length === 0) return false;
      return group.records.every(record => record.is_confirmed);
    },
    
    // 判断某条记录是否存在招生计划备注不全的情况
    // 逻辑：
    // 1. 统计招生计划备注中的年份种类数（plan_remark_list中的年份去重）
    // 2. 统计该组专业数据的年份种类数
    // 3. 如果专业数据的年份数 ≠ 招生计划年份数 × (专业数据总条数/招生计划年份数)，则标记为不全
    // 简单说：每个招生计划年份应该对应相同数量的专业数据记录
    // eslint-disable-next-line no-unused-vars
    isPlanRemarkIncomplete(record, group) {
      if (!record.plan_remark_list || record.plan_remark_list.length === 0) {
        return true; // 完全没有备注，肯定不全
      }
      return false; // 具体判断在 hasGroupIncompletePlanRemarks 中统一处理
    },
    
    // 判断一组是否存在备注不全的记录
    // 逻辑：
    // - 招生计划有N条，每个年份就应该有N条记录勾选
    // - 例如：招生计划1条 → 2025、2024、2023各需1条勾选
    // - 例如：招生计划2条 → 2025、2024、2023各需2条勾选
    hasGroupIncompletePlanRemarks(group) {
      if (!group.records || group.records.length === 0) return false;

      // 获取招生计划备注列表（取第一条记录的）
      const sampleRecord = group.records[0];
      const rawPlanRemarkList = sampleRecord.plan_remark_list || [];

      if (rawPlanRemarkList.length === 0) {
        return true; // 完全没有备注
      }

      // 过滤掉空选项（remark为空的项），获取实际有效的招生计划备注
      const planRemarkList = rawPlanRemarkList.filter(item => item.remark && item.remark.trim());

      if (planRemarkList.length === 0) {
        return true; // 没有有效的备注
      }

      // 招生计划条数
      const planItemCount = planRemarkList.length;

      // 按年份统计专业数据记录数和已勾选记录数
      const yearStats = {};
      
      group.records.forEach(record => {
        const year = String(record.admit_year || '未知');
        
        if (!yearStats[year]) {
          yearStats[year] = { total: 0, confirmed: 0 };
        }
        
        yearStats[year].total++;
        
        // 检查是否已勾选/确认
        const hasSelectedItems = record.selected_plan_items && record.selected_plan_items.length > 0;
        const isConfirmed = record.is_confirmed === true;
        
        if (hasSelectedItems || isConfirmed) {
          yearStats[year].confirmed++;
        }
      });

      // 检查每个年份的勾选数量是否等于招生计划条数
      for (const year in yearStats) {
        if (yearStats[year].confirmed !== planItemCount) {
          return true; // 该年份勾选数量不对，标记为不全
        }
      }

      return false; // 所有年份都勾选正确
    },
    
    // 切换一组的勾选状态（反选 -> 全选 -> 取消全选 -> 循环）
    toggleGroupSelection(group) {
      // 获取或初始化点击状态（0:初始, 1:反选后, 2:全选后, 3:取消后）
      if (group._clickState === undefined) {
        group._clickState = 0;
      }
      
      group._clickState++;
      if (group._clickState > 3) {
        group._clickState = 1;
      }
      
      switch (group._clickState) {
        case 1: // 反选
          group.records.forEach((record) => {
            this.$set(record, 'is_confirmed', !record.is_confirmed);
          });
          this.$message.info('已反选');
          break;
        case 2: // 全选
          group.records.forEach((record) => {
            this.$set(record, 'is_confirmed', true);
          });
          this.$message.success('已全选');
          break;
        case 3: // 取消全选
          group.records.forEach((record) => {
            this.$set(record, 'is_confirmed', false);
          });
          this.$message.warning('已取消全选');
          break;
      }
    },
    
    // 切换记录高亮状态（高亮同组所有记录）
    toggleRecordHighlight(record, group) {
      const groupKey = this.getGroupKey(group);
      if (this.highlightedRecordKey === groupKey) {
        this.highlightedRecordKey = null; // 取消高亮
      } else {
        this.highlightedRecordKey = groupKey; // 设置高亮
      }
    },
    
    // 判断记录是否高亮（同组记录都高亮）
    isRecordHighlighted(record, group) {
      if (!this.highlightedRecordKey) return false;
      return this.getGroupKey(group) === this.highlightedRecordKey;
    },
    
    // 获取组的唯一键
    getGroupKey(group) {
      return `${group.school_name}_${group.major_name}_${group.origin}_${group.batch}_${group.subject}`;
    },
    
    // 将选中文本添加到当前组已确认勾选的记录的排序列
    addSelectionToGroupSort(group) {
      const selection = window.getSelection();
      const selectedText = selection ? selection.toString().trim() : '';
      
      if (!selectedText) {
        this.$message.warning('请先选择要添加的文本');
        return;
      }
      
      // 筛选已确认勾选的记录
      const confirmedRecords = group.records.filter(record => record.is_confirmed);
      
      if (confirmedRecords.length === 0) {
        this.$message.warning('请先勾选要添加的记录');
        return;
      }
      
      // 添加到已确认记录的招生计划备注
      let updatedCount = 0;
      confirmedRecords.forEach((record) => {
        const currentPlanRemark = record.plan_remark || '';
        if (currentPlanRemark.includes(selectedText)) {
          return; // 已存在，跳过
        }
        const newPlanRemark = currentPlanRemark ? currentPlanRemark + ';' + selectedText : selectedText;
        this.$set(record, 'plan_remark', newPlanRemark);
        // 清除确认勾选框
        this.$set(record, 'is_confirmed', false);
        updatedCount++;
      });
      
      if (updatedCount > 0) {
        this.$message.success(`已添加到 ${updatedCount} 条记录的招生计划备注`);
      } else {
        this.$message.info('该文本已存在于所有勾选记录中');
      }
    },

    // ===== 快捷按钮方法 =====
    
    // 获取该组唯一的招生计划备注列表（用于下拉选择）
    getUniquePlanRemarks(group) {
      const remarks = [];
      const seen = new Set();
      
      // 从第一条记录获取 plan_remark_list
      if (group.records && group.records.length > 0) {
        const firstRecord = group.records[0];
        const planRemarkList = firstRecord.plan_remark_list || [];
        
        planRemarkList.forEach(item => {
          if (item.remark && !seen.has(item.remark)) {
            seen.add(item.remark);
            remarks.push(item);
          }
        });
      }
      
      return remarks;
    },
    
    // 处理招生计划备注选择变化（组级别）
    // eslint-disable-next-line no-unused-vars
    handlePlanRemarkSelect(group) {
      // 选择变化时不做任何操作，等待用户点击"填入排序列"按钮
    },
    
    // 处理单条记录的招生计划备注选择
    onPlanRemarkSelect(record) {
      // 将选中的招生备注自动填入并勾选确认
      if (record.selected_plan_remark) {
        this.$set(record, 'plan_remark', record.selected_plan_remark);
        this.$set(record, 'is_confirmed', true);
        this.$message.success('已选择该招生备注并勾选确认');
      } else {
        // 取消选择时，取消确认勾选
        this.$set(record, 'is_confirmed', false);
      }
    },
    
    // 将选中的招生备注应用到该组所有记录
    fillPlanRemarkToGroup(group) {
      const selectedRemark = group.selectedPlanRemark;
      if (!selectedRemark) {
        this.$message.warning('请先选择招生备注');
        return;
      }
      
      // 将选中的备注应用到该组所有记录
      let updatedCount = 0;
      group.records.forEach((record) => {
        this.$set(record, 'plan_remark', selectedRemark);
        updatedCount++;
      });
      
      this.$message.success(`已将选中的招生备注应用到 ${updatedCount} 条记录`);
    },
    
    // 勾选该组所有确认框
    confirmGroupAll(group) {
      group.records.forEach((record) => {
        this.$set(record, 'is_confirmed', true);
      });
      this.$message.success(`已勾选该组 ${group.records.length} 条记录`);
    },
    
    // 取消该组所有确认框
    cancelGroupAll(group) {
      group.records.forEach((record) => {
        this.$set(record, 'is_confirmed', false);
      });
      this.$message.success(`已取消该组 ${group.records.length} 条记录的勾选`);
    },

    // 重置本组所有数据（取消确认勾选）
    resetGroup(group) {
      // 使用 Element UI 的确认对话框
      this.$confirm(
        `确定要重置 "${group.school_name} - ${group.major_name}" 这 ${group.records.length} 条记录吗？<br>这将取消所有确认勾选。`,
        '确认重置',
        {
          confirmButtonText: '确定重置',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        // 用户确认后执行重置
        group.records.forEach((record) => {
          this.$set(record, 'is_confirmed', false);
        });
        this.$message.success(`已重置该组 ${group.records.length} 条记录`);
      }).catch(() => {
        // 用户取消，不做任何操作
        this.$message.info('已取消重置操作');
    });
    },

    // ===== 专业关联筛选方法 =====
    
    // 筛选条件变化时重置分页
    handleMajorMappingFilterChange() {
      this.majorMappingCurrentPage = 1;
    },
    
    // 重置专业关联筛选条件
    resetMajorMappingFilters() {
      this.majorMappingFilters = {
        batch: '',
        subject: '',
        origin: ''
      };
      this.majorMappingCurrentPage = 1;
      this.$message.success('已重置筛选条件');
    },

    // 定位到下一个未确认的组（循环定位）
    locateNextUnconfirmedGroup() {
      // 获取所有未确认的组索引
      const unconfirmedIndices = [];
      this.filteredMajorGroups.forEach((group, index) => {
        if (group.records && group.records.length > 0) {
          // 检查组内是否一个确认都没有（所有记录都未确认）
          if (group.records.every(record => !record.is_confirmed)) {
            unconfirmedIndices.push(index);
          }
        }
      });
      
      if (unconfirmedIndices.length === 0) {
        this.$message.success('所有组都已确认完成！');
        this.lastUnconfirmedIndex = -1;
        return;
      }
      
      // 确定下一个要定位的索引
      let nextIndex;
      if (this.lastUnconfirmedIndex === -1 || !unconfirmedIndices.includes(this.lastUnconfirmedIndex)) {
        // 第一次点击，定位到第一个
        nextIndex = unconfirmedIndices[0];
      } else {
        // 找到当前索引在数组中的位置，取下一个
        const currentPos = unconfirmedIndices.indexOf(this.lastUnconfirmedIndex);
        if (currentPos < unconfirmedIndices.length - 1) {
          nextIndex = unconfirmedIndices[currentPos + 1];
        } else {
          // 已经是最后一个，循环到第一个
          nextIndex = unconfirmedIndices[0];
          this.$message.info('已循环到第一个未确认组');
        }
      }
      
      this.lastUnconfirmedIndex = nextIndex;
      this.locateToGroupIndex(nextIndex, 'rgba(230, 162, 60, 0.3)', `已定位到第 ${unconfirmedIndices.indexOf(nextIndex) + 1}/${unconfirmedIndices.length} 个未确认组`);
    },
    
    // 通用定位方法
    locateToGroupIndex(groupIndex, highlightColor, message) {
      // 计算该组所在的页码
      const targetPage = Math.floor(groupIndex / this.majorMappingPageSize) + 1;
      
      // 切换到目标页
      if (targetPage !== this.majorMappingCurrentPage) {
        this.majorMappingCurrentPage = targetPage;
      }
      
      // 等待DOM更新后滚动到目标组的第一行
      this.$nextTick(() => {
        const firstRowRef = this.$refs['groupFirstRow_' + groupIndex];
        if (firstRowRef && firstRowRef[0]) {
          firstRowRef[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          // 添加高亮效果
          firstRowRef[0].style.transition = 'background-color 0.3s ease';
          const originalBg = firstRowRef[0].style.backgroundColor;
          firstRowRef[0].style.backgroundColor = highlightColor;
          setTimeout(() => {
            if (firstRowRef && firstRowRef[0]) {
              firstRowRef[0].style.backgroundColor = originalBg;
            }
          }, 2000);
          if (message) {
            this.$message.success(message);
          }
        } else {
          this.$message.warning('已找到目标组，但无法滚动到该位置');
        }
      });
    },

    // 定位到下一个招生计划备注不全的组（循环定位）
    locateFirstIncompletePlanRemarkGroup() {
      // 获取所有备注不全的组索引
      const incompleteIndices = [];
      this.filteredMajorGroups.forEach((group, index) => {
        if (this.hasGroupIncompletePlanRemarks(group)) {
          incompleteIndices.push(index);
        }
      });
      
      if (incompleteIndices.length === 0) {
        this.$message.success('所有组的招生计划备注都完整！');
        this.lastIncompleteIndex = -1;
        return;
      }
      
      // 确定下一个要定位的索引
      let nextIndex;
      if (this.lastIncompleteIndex === -1 || !incompleteIndices.includes(this.lastIncompleteIndex)) {
        // 第一次点击，定位到第一个
        nextIndex = incompleteIndices[0];
      } else {
        // 找到当前索引在数组中的位置，取下一个
        const currentPos = incompleteIndices.indexOf(this.lastIncompleteIndex);
        if (currentPos < incompleteIndices.length - 1) {
          nextIndex = incompleteIndices[currentPos + 1];
        } else {
          // 已经是最后一个，循环到第一个
          nextIndex = incompleteIndices[0];
          this.$message.info('已循环到第一个备注不全组');
        }
      }
      
      this.lastIncompleteIndex = nextIndex;
      this.locateToGroupIndex(nextIndex, 'rgba(245, 108, 108, 0.4)', `已定位到第 ${incompleteIndices.indexOf(nextIndex) + 1}/${incompleteIndices.length} 个备注不全组`);
    },

    // 手动确认备注全（标记为全，下次不再显示备注不全）
    async confirmIncompletePlanRemark(group) {
      try {
        // 标记为手动确认
        this.$set(group, '_manualConfirmedComplete', true);
        
        // 保存到后端
        const response = await axios.post('api/saveManualConfirmedComplete/', {
          school_name: group.school_name,
          major_name: group.major_name
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data && response.data.success) {
          this.$message.success('已确认备注全，下次加载将不再显示备注不全');
        } else {
          this.$message.error('保存确认状态失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('保存确认状态失败:', error);
        this.$message.error('保存确认状态失败，请检查网络连接');
      }
    },

    // 自动匹配专业备注（只对没有in_mapping的记录执行）
    async autoMatchMajorRemarks() {
      if (this.isAutoMatching) return;
      
      const groups = this.filteredMajorGroups;
      if (!groups || groups.length === 0) {
        return;
      }
      
      // 检查是否有需要自动匹配的记录（没有in_mapping的记录）
      let hasUnmatchedRecords = false;
      for (const group of groups) {
        for (const record of group.records) {
          if (!record.in_mapping) {
            hasUnmatchedRecords = true;
            break;
          }
        }
        if (hasUnmatchedRecords) break;
      }
      
      // 如果所有记录都已经有in_mapping匹配，则跳过自动匹配
      if (!hasUnmatchedRecords) {
        return;
      }
      
      this.isAutoMatching = true;
      
      try {
        // 准备请求数据（深拷贝避免影响原始数据）
        const requestGroups = JSON.parse(JSON.stringify(groups));
        
        const response = await axios.post('api/autoMatchMajorRemarks/', {
          groups: requestGroups,
          auto_confirm_threshold: 0.85
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data && response.data.success) {
          const result = response.data;
          
          // 创建记录ID到记录的映射，用于快速查找
          const recordMap = new Map();
          this.consecutiveMajorGroups.forEach(group => {
            group.records.forEach(record => {
              if (record.id) {
                recordMap.set(record.id, record);
              }
            });
          });
          
          // 应用匹配结果到原始数据（只更新没有in_mapping的记录）
          result.groups.forEach(matchedGroup => {
            matchedGroup.records.forEach(matchedRecord => {
              // 通过ID查找原始记录
              const originalRecord = recordMap.get(matchedRecord.id);
              // 只更新没有in_mapping的记录，并标记为自动匹配
              if (originalRecord && !originalRecord.in_mapping) {
                // 标记为自动匹配
                this.$set(originalRecord, '_isAutoMatched', true);
                // 更新匹配结果
                if (matchedRecord.selected_plan_item) {
                  this.$set(originalRecord, 'selected_plan_item', matchedRecord.selected_plan_item);
                  this.$set(originalRecord, 'selected_plan_items', [matchedRecord.selected_plan_item]);
                  this.$set(originalRecord, 'selected_plan_remark', matchedRecord.selected_plan_item.remark || '');
                }
                if (matchedRecord.is_confirmed !== undefined) {
                  this.$set(originalRecord, 'is_confirmed', matchedRecord.is_confirmed);
                }
              }
            });
          });
          
          // 统计有多少组包含自动匹配的记录（且不在in_mapping中）
          let autoConfirmedGroups = 0;
          let needsReviewGroups = 0;
          this.consecutiveMajorGroups.forEach(group => {
            const hasAutoConfirmed = group.records.some(r => r._isAutoMatched && !r.in_mapping && r.is_confirmed);
            const hasNeedsReview = group.records.some(r => r._isAutoMatched && !r.in_mapping && !r.is_confirmed);
            if (hasAutoConfirmed) autoConfirmedGroups++;
            if (hasNeedsReview) needsReviewGroups++;
          });
          
          // 更新统计信息
          this.autoMatchSummary = {
            total: autoConfirmedGroups + needsReviewGroups,
            confirmed: autoConfirmedGroups,
            review: needsReviewGroups
          };
          
          // 显示匹配统计
          const summary = result.summary;
          if (summary.auto_confirmed > 0 || summary.needs_review > 0) {
            let message = `自动匹配完成！\n`;
            message += `自动确认：${autoConfirmedGroups}组\n`;
            message += `需要复核：${needsReviewGroups}组`;
            this.$message.success(message);
          }
        }
      } catch (error) {
        console.error('自动匹配出错:', error);
      } finally {
        this.isAutoMatching = false;
      }
    },

    addSelectionToStandardRemark() {
      if (!this.majorMappingSelectedRecord || !this.majorMappingSelectedText) {
        this.$message.warning('没有选中的文本');
        this.closeMajorMappingContextMenu();
        return;
      }
      
      const record = this.majorMappingSelectedRecord;
      const selectedText = this.majorMappingSelectedText;
      
      // 追加到标准化备注
      let newRemark;
      if (record.standard_remark && record.standard_remark.trim()) {
        // 检查是否已包含该文本
        if (record.standard_remark.includes(selectedText)) {
          this.$message.info('该文本已存在于标准化备注中');
          this.closeMajorMappingContextMenu();
          return;
        } else {
          newRemark = record.standard_remark + ';' + selectedText;
          this.$message.success('已追加到标准化备注');
        }
      } else {
        newRemark = selectedText;
        this.$message.success('已设置为标准化备注');
      }
      
      // 使用$set确保响应式更新
      this.$set(record, 'standard_remark', newRemark);
      
      this.closeMajorMappingContextMenu();
    },

    // ===== 原有方法 =====
    // 处理科类变化（物理/历史切换时自动更新位次）
    async handleSubjectChange() {
      console.log('科类变化:', this.formData.subject1);
      if (typeof this.fetchRankData === 'function') {
        await this.fetchRankData();
      }
    },

    // 处理分数变化（点击外部或按Enter时触发）
    async handleScoreChange(event) {
      // 获取新值并转换为数字
      const newValue = parseInt(event.target.value, 10);
      
      // 获取旧值（直接使用 lastRecordedScore，不回退到 formData.scr_line）
      const oldValue = this.lastRecordedScore;
      
      // 先更新表单值，确保 fetchRankData 使用最新的分数
      this.formData.scr_line = newValue;
      
      console.log('handleScoreChange 更新分数:', newValue, 'formData:', JSON.parse(JSON.stringify(this.formData)));
      console.log('handleScoreChange fetchRankData 类型:', typeof this.fetchRankData);
      
      // 获取位次数据（使用更新后的分数）
      if (typeof this.fetchRankData === 'function') {
        await this.fetchRankData();
      } else {
        console.error('fetchRankData 不是函数:', this.fetchRankData);
      }
      
      console.log('handleScoreChange fetchRankData 完成后位次:', this.formData.admission_rank);

      // 如果值发生变化，记录修改
      if (!isNaN(newValue) && oldValue !== null && oldValue !== newValue) {
        console.log('分数发生变化:', oldValue, '->', newValue);
        
        // 记录分数修改并更新剩余次数
        if (typeof this.recordScoreChange === 'function') {
          await this.recordScoreChange('scr_line', oldValue, newValue);
        }
        
        // 更新最后记录的分数
        this.lastRecordedScore = newValue;
      }
    },

    // 启动登录状态轮询（智能轮询）
    startLoginStatusPolling() {
      // 如果已经存在定时器，先清除
      this.stopLoginStatusPolling();
      // 启动用户活动监听
      this.startUserActivityMonitoring();
      // 执行第一次轮询
      this.scheduleNextPoll();
    },

    // 调度下一次轮询
    scheduleNextPoll() {
      // 清除现有定时器
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }

      // 根据用户活跃状态决定轮询间隔
      const interval = this.isUserActive
        ? this.POLLING_INTERVAL_ACTIVE  // 活跃时：30秒
        : this.POLLING_INTERVAL_IDLE;   // 空闲时：2分钟

      this.loginStatusInterval = setTimeout(() => {
        if (this.isLoggedIn) {
          this.checkLoginStatus().then(() => {
            // 检查完成后继续调度下一次
            this.scheduleNextPoll();
          }).catch(() => {
            // 出错时也继续调度
            this.scheduleNextPoll();
          });
        }
      }, interval);
    },

    // 停止登录状态轮询
    stopLoginStatusPolling() {
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }
      // 停止用户活动监听
      this.stopUserActivityMonitoring();
    },

    // 启动用户活动监听
    startUserActivityMonitoring() {
      // 记录最后活动时间
      this.lastActivityTime = Date.now();
      this.isUserActive = true;

      // 监听用户活动事件
      const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
      this.handleUserActivity = () => {
        const now = Date.now();
        const wasIdle = !this.isUserActive;

        // 更新最后活动时间
        this.lastActivityTime = now;
        this.isUserActive = true;

        // 如果之前是空闲状态，现在恢复活跃，立即重新调度轮询
        if (wasIdle) {
          console.log('用户恢复活跃，缩短轮询间隔');
          this.scheduleNextPoll();
        }

        // 重置空闲检测定时器
        this.resetIdleTimeout();
      };

      activityEvents.forEach(event => {
        document.addEventListener(event, this.handleUserActivity, true);
      });

      // 启动空闲检测
      this.resetIdleTimeout();
    },

    // 停止用户活动监听
    stopUserActivityMonitoring() {
      if (this.handleUserActivity) {
        const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
        activityEvents.forEach(event => {
          document.removeEventListener(event, this.handleUserActivity, true);
        });
        this.handleUserActivity = null;
      }

      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
        this.userActivityTimeout = null;
      }
    },

    // 重置空闲检测定时器
    resetIdleTimeout() {
      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
      }

      this.userActivityTimeout = setTimeout(() => {
        // 超过空闲判定时间，标记为空闲
        const idleTime = Date.now() - this.lastActivityTime;
        if (idleTime >= this.IDLE_TIMEOUT) {
          console.log('用户进入空闲状态，延长轮询间隔');
          this.isUserActive = false;
          // 重新调度轮询，使用更长的间隔
          this.scheduleNextPoll();
        }
      }, this.IDLE_TIMEOUT);
    },

    // 加载分数修改限制信息
    loadScoreChangeLimitInfo() {
      axios.get('api/check-score-change-limit/', {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        if (response.data.success) {
          this.scoreChangeInfo = {
            can_change: response.data.can_change,
            remaining: response.data.remaining,
            limit_config: response.data.limit_config
          };
        }
      })
      .catch(error => {
        console.error('加载分数修改限制信息失败:', error);
        // 失败时设置为无限制
        this.scoreChangeInfo = {
          can_change: true,
          remaining: -1,
          limit_config: null
        };
      });
    },
    // 在设置登录状态的地方添加
    updateLoginStatus(isLoggedIn, username, isSuperAdmin) {
      this.isLoggedIn = isLoggedIn;
      this.username = username;
      this.isSuperAdmin = isSuperAdmin;

      // 保存到localStorage
      localStorage.setItem('isLoggedIn', isLoggedIn);
      localStorage.setItem('username', username);
      localStorage.setItem('isSuperAdmin', isSuperAdmin);
    },

    // 更新剩余修改次数
    updateScoreChangeRemaining(remaining, can_change) {
      // 使用Vue.set确保响应式更新
      this.$set(this.scoreChangeInfo, 'remaining', remaining);
      this.$set(this.scoreChangeInfo, 'can_change', can_change);
    },
    // 跳转到登录页面
    goToDashboard() {
      // 先强制滚动到顶部（不使用平滑动画）
      window.scrollTo(0, 0);
      // 确保滚动已完成
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      // 添加一个小延迟，确保滚动完成
      setTimeout(() => {
        this.$router.push('/dashboard');
      }, 100);
    },
    goToLogin() {
      // window.location.href = '/login/'
      this.$router.push('/login');

      // window.location.href = 'http://localhost:8000/login/'
    },
    goToMajors() {
      this.$router.push('/majors');
    },

    // 打开本地数据库前端
    openLocalServer() {
      window.open('http://localhost:8080', '_blank');
    },
    
    // 检查是否有VIP权限
    hasVipPermission() {
      // 超级管理员直接有权限
      if (this.isSuperAdmin === '超级管理员') {
        return true;
      }
      // 规划师(SVIP) - 后端已判断有效期
      if (this.userVipInfo?.is_svip) {
        return true;
      }
      // 管理员 - 后端已判断有效期
      if (this.userVipInfo?.is_admin) {
        return true;
      }
      // 普通VIP会员 - 后端已判断有效期
      if (this.userVipInfo?.is_vip) {
        return true;
      }
      return false;
    },
    
    // 处理导出Excel - 检查VIP权限
    handleExportExcel() {
      if (this.hasVipPermission()) {
        // 有权限，执行导出
        this.exportToExcel();
      } else {
        // 无权限，提示需要VIP
        this.$message.warning('💎 VIP专属功能，请先开通VIP');
      }
    },
    
    // 处理导入志愿表 - 检查VIP权限
    handleImportWishList() {
      if (this.hasVipPermission()) {
        // 有权限，执行导入
        this.importWishList();
      } else {
        // 无权限，提示需要VIP
        this.$message.warning('💎 VIP专属功能，请先开通VIP');
      }
    },
    
    // 处理导出筛选数据 - 检查VIP权限
    handleExportFilteredData() {
      if (this.hasVipPermission()) {
        // 有权限，执行导出
        this.exportFilteredData();
      } else {
        // 无权限，提示需要VIP
        this.$message.warning('💎 VIP专属功能，请先开通VIP');
      }
    },
    goToRegister() {
      // 使用Vue Router进行路由跳转，保持与其他组件一致
      this.$router.push('/register');
    },
    // 保留这个使用 axios 检查登录状态的版本
    checkLoginStatus() {
      // console.log('检查登录状态...');
      // 使用axios调用后端API检查登录状态
       // 获取CSRF令牌
      // const csrftoken = getCookie('csrftoken');
      return axios.get('api/check-login/', {
        // withCredentials: true ,
        // headers: {
        //   'X-Csrftoken': csrftoken
        // },
        // credentials: 'include'  // 确保发送cookie
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
        .then(response => {
          // console.log('登录状态API响应:', response.data);
          // 检查是否被踢出（异地登录）
          if (response.data.isKickedOut) {
            const deviceType = response.data.kickedOutInfo?.device_type || '其他设备';
            const kickedTime = response.data.kickedOutInfo?.kicked_at || '';
            this.$message.warning(
              `您的账号已在${deviceType}上登录，您已被踢出。\n登录时间：${kickedTime}`,
              5000
            );
            this.handleKickedOut();
            return response;
          }
          if (response.data.isLoggedIn) {
            this.isLoggedIn = true;
            this.username = response.data.displayName || response.data.username || '';
            this.isSuperAdmin = response.data.isSuperAdmin || '用户';
            // 登录后加载分数修改限制信息
            if (this.loadScoreChangeLimitInfo) {
              this.loadScoreChangeLimitInfo();
            }
            // 登录后加载VIP信息
            if (this.loadVipInfo) {
              this.loadVipInfo();
            }
            // 登录后启动消息轮询
            this.startMessagePolling();
            // this.$message.success(response.data.isSuperAdmin);
          } else {
            this.isLoggedIn = false;
            this.username = '';
            this.isSuperAdmin = '用户';
          }
          return response;
        })
        .catch(error => {
          console.error('检查登录状态失败:', error);
          // 开发环境下，可以临时设置为true以便调试UI
          // this.isLoggedIn = true;
          // this.username = '测试用户';
          this.isLoggedIn = false;
          this.username = '';
          throw error;
        });
    },

    // 处理被踢出
    handleKickedOut() {
      // 清除本地登录状态
      this.isLoggedIn = false;
      this.username = '';
      this.isSuperAdmin = '用户';
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('isSuperAdmin');

      // 停止登录状态轮询
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }

      // 停止消息轮询
      this.stopMessagePolling();

      // 调用后端登出
      axios.post('api/logout/', {}, {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      }).finally(() => {
        // 跳转到登录页
        this.$router.push('/login');
      });
    },
    // 保留这个与后端交互的退出登录版本
    // logout() {
    //   localStorage.removeItem('userInfo');
    //   this.isLoggedIn = false;
    //   this.username = '';
    //   window.location.reload();
    // },

    // 保留这个与后端交互的退出登录版本
    // 修复 logout 方法中的路径
    logout() {
      // 获取CSRF令牌
      // const csrftoken = getCookie('csrftoken');
      
      // 发送退出请求（修改为POST请求）
      axios.post('api/logout/', {}, {  // 移除尾随斜杠
        // withCredentials: true,
        // headers: { 'X-Csrftoken': csrftoken }
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(() => {
        // 退出成功后，更新本地状态
        this.isLoggedIn = false;
        this.isSuperAdmin = '用户';
        this.username = '';
            // 可选：清除本地存储的其他认证相关信息
        localStorage.removeItem('csrftoken');
        localStorage.removeItem('user');
        // 重新检查登录状态，确保前端和后端状态一致
        // this.$parent.checkLoginStatus();
      })
      .catch(error => {
        console.error('退出失败:', error);
        // 即使出错，也尝试更新状态
        this.isLoggedIn = false;
        this.username = '';
        localStorage.removeItem('csrftoken');
        localStorage.removeItem('user');
      });
    },
    // getCookie(name) {
    //   let cookieValue = null;
    //   if (document.cookie && document.cookie !== '') {
    //     const cookies = document.cookie.split(';');
    //     for (let i = 0; i < cookies.length; i++) {
    //       const cookie = cookies[i].trim();
    //       // 检查cookie是否以目标名称开头
    //       if (cookie.substring(0, name.length + 1) === (name + '=')) {
    //         cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
    //         break;
    //       }
    //     }
    //   }
    //   return cookieValue;
    // },
    loadCachedData() {
      // 这里可以添加额外的数据验证逻辑
      // 数据已在data中初始化时加载，这里可以为空或添加额外处理
      // 保存表单基本数据
      try {
        // 1. 加载表单基本数据
        const savedFormData = localStorage.getItem('savedFormData');
        if (savedFormData) {
          const parsedData = JSON.parse(savedFormData);
          if (this.validateFormData(parsedData)) {
            // 使用 Object.assign 保持响应式引用
            Object.assign(this.formData, parsedData);
            this.$message.success('已成功恢复基本表单数据');
          }
        }
      }
        catch (error) {
          console.error('从localStorage恢复数据时出错:', error);
          this.$message.error('恢复表单数据时出错，请手动填写');
        }
    },
    // 保存表单数据到localStorage
    saveFormDataToStorage() {
      try {
        // 保存表单基本数据
        localStorage.setItem('savedFormData', JSON.stringify(this.formData));

        // 保存单独的学生基本信息（保持向后兼容）
        localStorage.setItem('student_origin', this.formData.origin || '江苏');
       
        localStorage.setItem('student_name', this.formData.student_name || 'XXX');
        localStorage.setItem('student_gender', this.formData.gender || '男');
        localStorage.setItem('student_score', this.formData.scr_line || '600');

        localStorage.setItem('student_batch', this.formData.batch || '本科批');
        localStorage.setItem('student_enrollment_type', this.formData.enrollment_type || '');
        localStorage.setItem('student_subject1', this.formData.subject1 || '物理');
        localStorage.setItem('student_subject2', this.formData.subject2 || '化学');
        localStorage.setItem('student_subject3', this.formData.subject3 || '生物');
        localStorage.setItem('student_rank', this.formData.admission_rank || '');
        localStorage.setItem('same_rank_score', this.formData.same_rank_score || '');
        
        
        // this.$message.success('表单数据已保存');
      } catch (error) {
        console.error('保存表单数据到localStorage时出错:', error);
        this.$message.error('保存表单数据失败');
      }
      },
      // 添加自动保存功能
  setupAutoSave() {
    // 监听表单数据变化自动保存
    this.$watch('formData', () => {
      this.saveFormDataToStorage();
    }, { deep: true });
    
    this.$watch('professionalRows', () => {
      this.saveFormDataToStorage();
    }, { deep: true });
    
    this.$watch('wishList', () => {
      this.saveFormDataToStorage();
    }, { deep: true });
    
    // 设置定时器定期保存，以防监听失效
    setInterval(() => {
      this.saveFormDataToStorage();
    }, 30000); // 每30秒自动保存一次
  },
    // 处理表格列名，根据columnComments显示注释
    handleCurrentChange(val) {
      // 保存当前页码（用于权限不足时恢复）
      const originalPage = this.pagination.currentPage;
      
      // 如果未登录，跳转到登录页面
      if (!this.isLoggedIn) {
        this.goToLogin();
        // 阻止页码切换，强制重置回第1页
        this.pagination.currentPage = 1;
        return;
      }
      // 第1页可以直接访问，其他页码需要VIP权限
      if (val > 1 && !this.hasVipPermission()) {
        this.$message.warning('💎 VIP专属功能，第2页起需要VIP权限');
        // 阻止页码切换，恢复到原来的页码
        this.$nextTick(() => {
          this.pagination.currentPage = originalPage;
        });
        return;
      }
      
      // 用户已登录或点击的是第1页，正常加载数据
      this.isLoading = true;
      // 同步两个页码变量，确保一致
      this.currentPage = val;
      this.pagination.currentPage = val;
      
      // 修改：添加异步处理，等待数据加载并显示成功提示
      this.fetchCollegeAdmission().then(() => {
        // 使用setTimeout确保DOM已更新并且表格已准备就绪
        setTimeout(() => {
          // 检查表格是否已渲染完成
          if (this.$refs.dataTable) {
            this.isLoading = false;
          }
        }, 500); // 延迟500ms确保表格完全渲染
      }).catch(error => {
        console.error('加载数据失败:', error);
        this.isLoading = false;
        this.$message.error('加载数据失败，请重试');
      });
    },

    handleSizeChange(val) {
      this.isLoading = true;
      this.pageSize = val;
      this.pagination.pageSize = val;
      this.currentPage = 1; // 重置到第一页
      this.pagination.currentPage = 1; // 同步更新分页状态
     // 修改：添加异步处理，等待数据加载并显示成功提示
      this.fetchCollegeAdmission().then(() => {
        // 使用setTimeout确保DOM已更新并且表格已准备就绪
        setTimeout(() => {
          // 检查表格是否已渲染完成
          if (this.$refs.dataTable) {
            this.isLoading = false;
          }
        }, 500); // 延迟500ms确保表格完全渲染
      }).catch(error => {
        console.error('加载数据失败:', error);
        this.isLoading = false;
        this.$message.error('加载数据失败，请重试');
      });
    },
    // 处理跳转到指定页
    handleJumpPage() {
      const maxPage = Math.ceil(this.schoolCount / this.pagination.pageSize);
      let targetPage = parseInt(this.jumpPage);
      
      if (isNaN(targetPage) || targetPage < 1) {
        targetPage = 1;
      } else if (targetPage > maxPage) {
        targetPage = maxPage;
      }
      
      this.jumpPage = targetPage;
      this.handleCurrentChange(targetPage);
    },
    // 节流函数，限制函数调用频率
    throttle(fn, delay) {
      let lastCall = 0;
      return function(...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return fn.apply(this, args);
      };},
      // 优化滚动处理
    handleTableScroll(event) {
      if (this.isScrolling) return;
      
      this.isScrolling = true;
      clearTimeout(this.scrollTimeout);
      
      
      // 防抖处理，滚动停止后再执行耗时操作
      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
        // 滚动停止后执行加载或其他操作
        if (this.shouldLoadMore(event)) {
          // 使用 requestAnimationFrame 确保滚动完成后再加载
          requestAnimationFrame(() => {
            this.throttledLoadMore();
          });
        }
      }, 200); // 增加延迟，减少高频触发
    },
    
    // 判断是否需要加载更多数据
    shouldLoadMore(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到距离底部100px时加载更多
      return scrollHeight - scrollTop - clientHeight < 200;
    },
  
    // 设置表头样式的函数
    // 简化的表头样式设置函数
    // 修改表头样式的函数
    setHeaderStyles() {
      // 使用 requestAnimationFrame 代替嵌套的 setTimeout
      requestAnimationFrame(() => {
        // 合并表头和表体单元格处理，减少 DOM 查询次数
        const headerCells = document.querySelectorAll('.el-table__header th');
        const headerTexts = [];
        
        // 先收集表头信息，减少重复的 DOM 查询
        headerCells.forEach(th => {
          const cell = th.querySelector('.cell');
          if (cell) {
            const text = cell.textContent.trim();
            headerTexts.push(text);
            
            // 清除并添加表头样式
            th.classList.remove('special-school-name', 'special-major-name', 'special-major-remark');
            th.style.cssText = '';
            cell.style.cssText = '';
            
            if (text === '学校名') th.classList.add('special-school-name');
            else if (text === '专业名称') th.classList.add('special-major-name');
            else if (text === '专业备注') th.classList.add('special-major-remark');
          }
        });
        
        // 使用批处理减少重排重绘
        requestAnimationFrame(() => {
          // 只更新需要更新的表格
          const tables = document.querySelectorAll('.el-table');
          tables.forEach(table => {
            if (table.__vue__ && table.__vue__.doLayout) {
              table.__vue__.doLayout();
            }
          });
        });
      });
    },
    /**
     * 检查是否从院校库跳转过来并自动搜索
     */
    async checkAndSearchFromSchool() {
      // console.log('checkAndSearchFromSchool 开始执行')
      // console.log('当前URL:', window.location.href)
      // console.log('URL hash:', window.location.hash)
      // console.log('formData.admit_year:', this.formData.admit_year)
      
      // 检查admit_year是否有效
      if (!this.formData.admit_year || this.formData.admit_year <= 0) {
        console.log('admit_year无效，等待fetchMaxDataYear完成...')
        // 等待一段时间再试
        await new Promise(resolve => setTimeout(resolve, 1000))
        console.log('等待后 formData.admit_year:', this.formData.admit_year)
        
        // 如果还是无效，手动获取
        if (!this.formData.admit_year || this.formData.admit_year <= 0) {
          console.log('手动调用fetchMaxDataYear')
          if (this.fetchMaxDataYear) {
            await this.fetchMaxDataYear()
          }
        }
      }
      
      console.log('最终 formData.admit_year:', this.formData.admit_year)
      
      // 获取URL参数（兼容hash模式和history模式）
      let searchSchoolName = null
      
      try {
        // hash模式下，参数在hash中，格式如 /#/?school=xxx
        let queryString = ''
        const hash = window.location.hash || ''
        
        // 从hash中提取查询参数部分（?后面的内容）
        const hashQueryIndex = hash.indexOf('?')
        if (hashQueryIndex !== -1) {
          queryString = hash.substring(hashQueryIndex + 1)
          console.log('从hash中提取的查询字符串:', queryString)
        }
        
        // 如果hash中没有，尝试从search中获取（history模式）
        if (!queryString && window.location.search) {
          queryString = window.location.search.substring(1)
          console.log('从search中提取的查询字符串:', queryString)
        }
        
        // 解析查询参数
        if (queryString) {
          const urlParams = new URLSearchParams(queryString)
          searchSchoolName = urlParams.get('school')
          console.log('从URL参数获取学校名:', searchSchoolName)
          
          if (searchSchoolName) {
            searchSchoolName = decodeURIComponent(searchSchoolName)
            console.log('解码后的学校名:', searchSchoolName)
          }
        }
      } catch (e) {
        console.error('解析URL参数失败:', e)
      }
      
      // 如果URL没有，再从localStorage读取（兼容旧方式）
      if (!searchSchoolName) {
        searchSchoolName = localStorage.getItem('searchSchoolName')
        console.log('从localStorage获取学校名:', searchSchoolName)
        if (searchSchoolName) {
          localStorage.removeItem('searchSchoolName')
        }
      }
      
      if (searchSchoolName) {
        console.log('准备搜索学校:', searchSchoolName)
        
        // 清除URL参数（不影响后续刷新）
        try {
          // hash模式下清除参数
          const hash = window.location.hash || ''
          const hashPathIndex = hash.indexOf('?')
          if (hashPathIndex !== -1) {
            const cleanHash = hash.substring(0, hashPathIndex)
            window.history.replaceState({}, '', cleanHash || '/')
          }
        } catch (e) {
          console.error('清除URL参数失败:', e)
        }
        
        // 设置搜索目标为筛选表
        this.searchTargetTable = 'filtered'
        
        // 将学校名称填充到专业行的学校名输入框（第一行）
        if (this.professionalRows && this.professionalRows.length > 0) {
          this.professionalRows[0].schoolName = searchSchoolName
        } else {
          // 如果没有专业行，创建一个并填充学校名
          this.professionalRows = [{
            professional: '',
            tag: '',
            schoolName: searchSchoolName,
            schoolProvince: '',
            schoolType: '',
            professionalRemark: ''
          }]
        }
        
        console.log('professionalRows已设置:', this.professionalRows)
        console.log('formData:', this.formData)
        
        // 显示提示
        this.$message.info(`正在查询"${searchSchoolName}"的志愿数据，请稍候...`)
        
        // 设置跳过位次筛选标志，让 fetchCollegeAdmission 使用
        this._skipRankFilterFromSchool = true
        
        // 调用完整的筛选志愿功能
        await this.fetchCollegeAdmission()
        
        // 清除标志
        this._skipRankFilterFromSchool = false
        
        // 筛选完成后清空学校名
        if (this.professionalRows && this.professionalRows.length > 0) {
          this.professionalRows[0].schoolName = ''
        }
        
        // 滚动到筛选表标题（仅小屏）
        this.$nextTick(() => {
          setTimeout(() => {
            // 判断是否小屏（宽度小于768px）
            const isSmallScreen = window.innerWidth < 768
            if (isSmallScreen) {
              const titleEl = this.$refs.filteredTableTitle
              if (titleEl) {
                titleEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            }
          }, 500)
        })
      } else {
        console.log('没有检测到学校名参数')
      }
    },

    /**
     * 检查是否从Dashboard跳转过来查看志愿记录
     */
    checkAndOpenWishlistHistory() {
      const shouldOpenWishlist = localStorage.getItem('openWishlistHistory');
      if (shouldOpenWishlist === 'true') {
        // 清除标记
        localStorage.removeItem('openWishlistHistory');
        // 延迟执行，等待页面完全加载
        setTimeout(() => {
          this.openWishlistHistory();
        }, 500);
      }
    },

    /**
     * 处理学校定位功能
     * 支持在筛选表和志愿表中搜索定位
     * 通过选择目标表格，在对应表格中查找匹配项
     */
    handleLocateSchool() {
      try {
        const searchSchool = this.searchSchool.trim().toLowerCase();
        const searchMajor = this.searchMajor.trim().toLowerCase();
       
        if (!searchSchool && !searchMajor) {
          this.$message.warning('请输入学校名称或专业名称进行搜索');
          return;
        }
        
        // 根据选择的目标表格获取数据和引用
        const isFilteredTable = this.searchTargetTable === 'filtered';
        const tableData = isFilteredTable ? (this.filteredData || []) : (this.wishList || []);
        const tableRefName = isFilteredTable ? 'dataTable' : 'wishTable';
        const tableName = isFilteredTable ? '筛选表' : '志愿表';
        
        if (tableData.length === 0) {
          this.$message.warning(`${tableName}中没有数据，请先添加数据到${tableName}`);
          return;
        }
        
        // 修复：使用正确的路径引用
        let startIndex = (this.currentSearchIndex + 1) % tableData.length;
        let foundIndex = -1;
        
        // 从上次找到的位置开始，循环查找匹配项
        for (let i = 0; i < tableData.length; i++) {
          const currentIndex = (startIndex + i) % tableData.length;
          const item = tableData[currentIndex];
          
          // 确保字段名与表格中的数据结构匹配
          const schoolMatch = !searchSchool || 
                     (item.schoolName && String(item.schoolName).toLowerCase().includes(searchSchool)) ||
                     (item.school_name && String(item.school_name).toLowerCase().includes(searchSchool));
          const majorMatch = !searchMajor || 
                    (item.majorName && String(item.majorName).toLowerCase().includes(searchMajor)) ||
                    (item.major_name && String(item.major_name).toLowerCase().includes(searchMajor)) ||
                    (item.professional && String(item.professional).toLowerCase().includes(searchMajor));
          
          if (schoolMatch && majorMatch) {
            foundIndex = currentIndex;
            break;
          }
        }
        
        if (foundIndex !== -1) {
          // 修复：使用正确的路径更新currentSearchIndex
          this.currentSearchIndex = foundIndex;
          
          // 定位到找到的行
          this.$nextTick(() => {
            const tableRef = this.$refs[tableRefName];
            if (!tableRef) {
              this.$message.warning(`无法找到${tableName}，请确保表格已加载`);
              return;
            }
            const tableWrapper = tableRef.$el.querySelector('.el-table__body-wrapper');
            
            if (tableWrapper && tableRef) {
              // 设置当前行高亮
              tableRef.setCurrentRow(tableData[foundIndex]);
              
              // 改进：更精确地滚动到匹配行
              const tableBody = tableWrapper.querySelector('.el-table__body');
              if (tableBody) {
                // 获取所有行元素
                const rows = tableBody.querySelectorAll('tr');
                if (rows[foundIndex]) {
                  // 获取行元素的位置并滚动
                  const rowElement = rows[foundIndex];
                  const rowTop = rowElement.offsetTop;
                  
                  // 滚动到行的位置，并留出一定的顶部边距
                  tableWrapper.scrollTo({
                    top: Math.max(0, rowTop - 100),
                    behavior: 'smooth'
                  });
                  
                  // 高亮显示找到的行
                  setTimeout(() => {
                    rowElement.classList.add('highlight-row');
                    setTimeout(() => {
                      rowElement.classList.remove('highlight-row');
                    }, 2000); // 2秒后移除高亮
                  }, 300);
                }
              }
              
              // 获取匹配项的名称，适应不同的数据结构
              const schoolName = tableData[foundIndex].schoolName || tableData[foundIndex].school_name || '未知学校';
              const majorName = tableData[foundIndex].majorName || tableData[foundIndex].major_name || 
                               tableData[foundIndex].professional || '未知专业';
              
              // 显示找到的信息
              this.$message.success(`已定位到${tableName}匹配项：${schoolName} - ${majorName}`);
            } else {
              console.error(`${tableName}引用不存在`);
            }
          });
        } else {
          // 修复：使用正确的路径重置currentSearchIndex
          this.currentSearchIndex = -1;
          this.$message.info(`${tableName}中未找到匹配的学校和专业`);
        }
      } catch (error) {
        // console.error('定位功能出错:', error);
        this.$message.error('志愿表定位功能发生错误，请查看控制台');
      }
    },
    
    
    // 设置表头单元格样式
    getHeaderCellStyle(columnName) {
      const textLength = columnName.trim().length;
      if (textLength === 2 || textLength === 3) {
        // 竖排文字
        return {
          writingMode: 'vertical-rl',
          textOrientation: 'upright',
          fontSize: '14px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '120px'
        };
      } else if (textLength === 4 || textLength === 5) {
        // 两行显示
        return {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '12px',
          height: '60px'
        };
      }
      return {};
    },
    /**
   * 处理保存列宽按钮点击事件
   */

    handleSaveColumnWidths() {
      // 使用 requestAnimationFrame 确保在渲染周期结束后处理
      requestAnimationFrame(() => {
        try {
          const tempWidths = {};

          // 只使用一种获取方式，减少 DOM 操作
          const tables = document.querySelectorAll('.el-table');
          if (tables.length === 0) {
            if (this.$message) {
              this.$message.warning('未能找到筛选表元素');
            }
            return;
          }

          const headerCells = tables[0].querySelectorAll('.el-table__header th');

          // 批量处理
          headerCells.forEach(th => {
            const cell = th.querySelector('.cell');
            if (!cell) return;

            const columnKey = cell.textContent.trim();
            const width = th.offsetWidth;

            if (columnKey && width > 0) {
              tempWidths[columnKey] = width;
            }
          });

          // 直接更新
          this.columnWidths = { ...tempWidths };

          // 保存
          this.saveColumnWidths();

          if (this.$message) {
            this.$message.success(`成功保存 ${Object.keys(tempWidths).length} 列的宽度设置`);
          }
        } catch (error) {
          console.error('保存列宽时出错:', error);
          if (this.$message) {
            this.$message.error('保存列宽时发生错误');
          }
        }
      });
    },

    /**
     * 恢复默认列宽
     */
    restoreDefaultColumnWidths() {
      // 清除本地存储的列宽设置
      localStorage.removeItem(this.columnWidthStorageKey);
      // 直接从数据库获取默认列宽（不调用 loadColumnWidths，避免延迟）
      this.columnWidths = {};
      axios.get('api/table_column_widths_default/')
        .then(response => {
          if (response.data.success) {
            this.columnWidths = response.data.defaultWidths;
            console.log('恢复默认列宽:', this.columnWidths);
            // 强制 Vue 更新
            this.$forceUpdate();
            // 延迟后应用列宽
            this.$nextTick(() => {
              this.applyColumnWidths();
            });
            if (this.$message) {
              this.$message.success('已恢复默认列宽');
            }
          }
        })
        .catch(error => {
          console.error('恢复默认列宽失败:', error);
          if (this.$message) {
            this.$message.error('恢复默认列宽失败');
          }
        });
    },

    // 添加方法
    handleTableLoad() {
      // 这个方法可以处理表格加载时的逻辑
      // 比如应用列宽设置、设置表头样式等
      // console.log('表格加载完成');
      this.$nextTick(() => {
        // 应用保存的列宽设置
        if (this.applyColumnWidths) {
          this.applyColumnWidths();
        }
        // 设置表头样式
        if (this.setHeaderStyles) {
          this.setHeaderStyles();
        }
      });
    },
    // 处理列宽调整完成事件
    onColumnResizeEnd(column, event) {
      try {
        // 简化处理，直接使用 event.width
        let width = event && event.width ? event.width : 0;
        
        // 使用列标签作为键
        const key = column.label || column.property;
        
        if (key && width > 0) {
          // 延迟更新，减少频繁计算
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => {
            this.updateColumnWidth({
              prop: key,
              width: width
            });
          }, 100);
        }
      } catch (error) {
        console.error('处理列宽调整事件时出错:', error);
      }
    },

    // ========== 志愿表保存相关方法 ==========
    
    // 打开保存志愿表弹窗
    openSaveWishlistDialog() {
      // 先检查VIP权限，普通用户先提醒开通VIP
      if (!this.hasVipPermission()) {
        this.$message.warning('💎 VIP专属功能，请先开通VIP');
        return;
      }
      // 有权限的情况下，才检查志愿表是否为空
      if (this.wishList.length === 0) {
        this.$message.warning('志愿表为空，请先添加志愿');
        return;
      }
      // 自动填充表单信息
      this.wishlistForm.student_name = this.formData.student_name || '';
      // 获取当前自动排序模式名称
      const sortModeNames = {
        maxRank: '当前数据排序',
        minScoreRank: '组内最低位次排序',
      };
      const sortModeName = sortModeNames[this.wishSortMode] || '';
      const baseName = this.formData.student_name ? `${this.formData.student_name}的志愿表` : '我的志愿表';
      this.wishlistForm.name = sortModeName ? `${baseName}（${sortModeName}）` : baseName;
      this.showSaveWishlistDialog = true;
    },
    
    // 关闭保存志愿表弹窗
    closeSaveWishlistDialog() {
      this.showSaveWishlistDialog = false;
      this.wishlistForm = {
        name: '',
        student_name: '',
        remark: ''
      };
    },
    
    // 保存志愿表
    async saveWishlist() {
      if (this.wishList.length === 0) {
        this.$message.warning('志愿表为空，无法保存');
        return;
      }
      
      this.isSavingWishlist = true;
      
      try {
        const studentInfo = {
          student_name: this.wishlistForm.student_name || this.formData.student_name,
          origin: this.formData.origin,
          admit_year: this.formData.admit_year,
          gender: this.formData.gender,
          subject: `${this.formData.subject1}+${this.formData.subject2}+${this.formData.subject3}`,
          batch: this.formData.batch,
          score: this.formData.scr_line,
          admission_rank: this.formData.admission_rank,
          rush_rank: this.formData.rush_rank,
          stable_rank: this.formData.stable_rank,
          safe_rank: this.formData.safe_rank
        };
        
        const response = await axios.post('api/save-wishlist/', {
          name: this.wishlistForm.name,
          student_info: studentInfo,
          wishlist: this.wishList,
          remark: this.wishlistForm.remark
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken'
        });
        
        if (response.data.success) {
          this.$message.success(`志愿表保存成功！共保存 ${response.data.item_count} 个志愿`);
          this.closeSaveWishlistDialog();
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      } catch (error) {
        console.error('保存志愿表失败:', error);
        // 403错误已在openSaveWishlistDialog中通过VIP检查处理，如果是403则不重复提示
        if (error.response?.status === 403) {
          this.$message.warning('💎 VIP专属功能，请先开通VIP');
        } else {
          this.$message.error(error.response?.data?.message || '保存失败，请稍后重试');
        }
      } finally {
        this.isSavingWishlist = false;
      }
    },
    
    // 打开志愿表历史记录弹窗
    async openWishlistHistory() {
      // 检查VIP权限
      if (!this.hasVipPermission()) {
        this.$message.warning('💎 VIP专属功能，请先开通VIP');
        return;
      }
      await this.loadWishlistHistory();
      this.showWishlistHistoryDialog = true;
    },
    
    // 关闭志愿表历史记录弹窗
    closeWishlistHistoryDialog() {
      this.showWishlistHistoryDialog = false;
    },
    
    // 加载志愿表历史记录
    async loadWishlistHistory() {
      try {
        const response = await axios.get('api/wishlist-history/', {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.wishlistHistory = response.data.data || [];
        } else {
          // 非VIP权限错误不显示，已在openWishlistHistory中处理
          if (response.status !== 403) {
            this.$message.error(response.data.message || '加载失败');
          }
        }
      } catch (error) {
        console.error('加载志愿表历史失败:', error);
        // 403错误已在openWishlistHistory中通过VIP检查处理，不重复提示
        if (error.response?.status !== 403) {
          this.$message.error('加载志愿表历史失败');
        }
      }
    },
    
    // 查看志愿表详情
    async viewWishlistDetail(wishlistId) {
      try {
        const response = await axios.get(`api/wishlist/${wishlistId}/`, {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.wishlistDetail = response.data.data;
          this.showWishlistDetailDialog = true;
        } else {
          this.$message.error(response.data.message || '加载详情失败');
        }
      } catch (error) {
        console.error('加载志愿表详情失败:', error);
        this.$message.error('加载详情失败');
      }
    },
    
    // 关闭志愿表详情弹窗
    closeWishlistDetailDialog() {
      this.showWishlistDetailDialog = false;
      this.wishlistDetail = null;
    },

    // ============ 志愿表详情拖拽排序 ============

    // 小组拖拽开始（拖拽专业名称单元格）
    onWishGroupDragStart(event, group) {
      console.log('[拖拽] 小组 dragstart', group?.key);
      this.wishDetailDragType = 'group';
      this.wishDetailDragGroup = group;
      this.wishDetailDragSchool = null;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', group.key);
    },

    // 专业拖拽开始（拖拽专业名称单元格 — 只能在小组内部拖动）
    onWishMajorDragStart(event, group, majorIdx) {
      // 占位符不允许拖动
      const major = group.majors[majorIdx];
      if (major && major.isPlaceholder) {
        event.preventDefault();
        return;
      }
      console.log('[拖拽] 专业 dragstart', { groupKey: group.key, majorIdx, majorName: major?.majorName });
      this.wishDetailDragType = 'major';
      this.wishDetailDragGroupKey = group.key;
      this.wishDetailDragMajorIdx = majorIdx;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', group.key + '-' + majorIdx);
    },

    // 大组拖拽开始（拖拽序号单元格）
    onWishSchoolDragStart(event, group) {
      console.log('[拖拽] 大组 dragstart', group.schoolName);
      this.wishDetailDragType = 'school';
      this.wishDetailDragSchool = group.schoolName;
      this.wishDetailDragGroup = null;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', group.schoolName);
    },

    // 拖拽经过（设置悬停高亮）
    onWishDragOver(event, group) {
      event.preventDefault();
      if (this.wishDetailDragType === 'major') {
        // 专业拖动：仅同组高亮
        if (this.wishDetailDragGroupKey === group.key) {
          this.wishDetailDropKey = group.key;
        }
      } else {
        this.wishDetailDropKey = group.key;
      }
    },

    // 拖拽离开（取消高亮）
    onWishDragLeave() {
      this.wishDetailDropKey = null;
    },

    // 拖拽放下
    onWishDrop(event, targetGroup, targetMajorIdx) {
      event.preventDefault();
      this.wishDetailDropKey = null;
      this.wishDetailMovedKeys = [];

      const dragType = this.wishDetailDragType;
      console.log('[拖拽] drop 触发', dragType, { targetSchool: targetGroup?.schoolName, targetKey: targetGroup?.key, targetMajorIdx });
      let movedKeys = [];
      if (dragType === 'major' && this.wishDetailDragGroupKey != null) {
        this._reorderMajorInGroup(this.wishDetailDragGroupKey, this.wishDetailDragMajorIdx, targetGroup, targetMajorIdx);
        movedKeys = [];
        this.wishDetailMovedMajorKey = { groupKey: targetGroup.key, majorIdx: targetMajorIdx };
      } else if (dragType === 'group' && this.wishDetailDragGroup) {
        this._reorderGroup(this.wishDetailDragGroup, targetGroup);
        movedKeys = [this.wishDetailDragGroup.key];
      } else if (dragType === 'school' && this.wishDetailDragSchool) {
        this._reorderSchool(this.wishDetailDragSchool, targetGroup);
        const movedSchool = this.wishDetailDragSchool;
        const schoolGroups = (this.wishlistDetailGrouped || [])
          .filter(g => g.schoolName === movedSchool);
        // 只标第一个组，避免多个组全标色
        movedKeys = schoolGroups.length > 0 ? [schoolGroups[0].key] : [];
      }

      if (movedKeys.length > 0) {
        this.wishDetailMovedKeys = movedKeys;
        this.$message.success('移动成功');
      }

      this.wishDetailDragType = null;
      this.wishDetailDragGroup = null;
      this.wishDetailDragGroupKey = null;
      this.wishDetailDragMajorIdx = null;
      this.wishDetailDragSchool = null;
    },

    // 拖拽结束（清理状态）
    onWishDragEnd() {
      this.wishDetailDragType = null;
      this.wishDetailDragGroup = null;
      this.wishDetailDragSchool = null;
      this.wishDetailDragGroupKey = null;
      this.wishDetailDragMajorIdx = null;
      this.wishDetailDropKey = null;
    },

    // 点击表格清除移动高亮
    clearWishDetailMovedHighlight() {
      this.wishDetailMovedKeys = [];
      this.wishDetailMovedMajorKey = null;
    },

    /** 获取数据项的组key（与 wishlistDetailGrouped 中的 key 计算逻辑一致） */
    _getItemGroupKey(item) {
      const sName = item.school_name || item.学校名称 || '';
      const mGroup = item.major_group || item.专业组 || '';
      return `${sName}_${mGroup}`;
    },

    /** 获取数据项的学校key */
    _getItemSchoolKey(item) {
      return item.school_name || item.学校名称 || '';
    },

    /** 在 wishlistDetail.items 中移动小组（专业组）到新位置（按拖动方向） */
    _reorderGroup(dragGroup, targetGroup) {
      const dragKey = dragGroup.key;
      const targetKey = targetGroup.key;
      if (dragKey === targetKey) {
        console.log('[小组] 同一组，不移动');
        return;
      }

      // 获取当前所有组的 key 序列
      const items = this.wishlistDetail.items;
      const groupKeys = [];
      const seen = new Set();
      items.forEach(item => {
        const key = this._getItemGroupKey(item);
        if (!seen.has(key)) {
          seen.add(key);
          groupKeys.push(key);
        }
      });

      const dragIdx = groupKeys.indexOf(dragKey);
      const targetIdx = groupKeys.indexOf(targetKey);
      if (dragIdx === -1 || targetIdx === -1) {
        console.log('[小组] 未找到索引', { dragKey, targetKey, dragIdx, targetIdx });
        return;
      }

      console.log('[小组] 原始顺序', groupKeys, '拖拽索引', dragIdx, '目标索引', targetIdx);

      // 移除拖拽组
      groupKeys.splice(dragIdx, 1);

      // 按拖动方向决定插入位置：
      // - 从下往上拖（dragIdx > targetIdx）：插到目标之前
      // - 从上往下拖（dragIdx < targetIdx）：插到目标之后
      let insertAt = groupKeys.indexOf(targetKey);
      if (dragIdx < targetIdx) {
        insertAt = insertAt + 1;
      }
      groupKeys.splice(insertAt, 0, dragKey);
      console.log('[小组] 新组顺序', groupKeys);

      // 按新顺序重建 items
      const newItems = [];
      groupKeys.forEach(key => {
        items.forEach(item => {
          if (this._getItemGroupKey(item) === key && !newItems.includes(item)) {
            newItems.push(item);
          }
        });
      });
      items.forEach(item => {
        if (!newItems.includes(item)) newItems.push(item);
      });

      newItems.forEach((item, idx) => { item.order = idx + 1; });
      this.wishlistDetail.items = newItems;
      this.syncDetailOrderToWishList();
    },

    /** 在同一小组内重排专业顺序（按拖动方向，不依赖鼠标在行内的位置） */
    _reorderMajorInGroup(dragGroupKey, dragMajorIdx, targetGroup, targetMajorIdx) {
      // 只能在同一组内拖动
      if (dragGroupKey !== targetGroup.key) {
        console.log('[专业] 不同小组，专业不能跨组拖动');
        return;
      }
      // 索引相同，不移动
      if (dragMajorIdx === targetMajorIdx) {
        console.log('[专业] 同一专业，不移动');
        return;
      }

      const items = this.wishlistDetail.items;

      // 收集该组所有项在 items 中的引用
      const groupItemRefs = [];
      items.forEach((item, idx) => {
        if (this._getItemGroupKey(item) === dragGroupKey) {
          groupItemRefs.push({ item, idx });
        }
      });

      if (groupItemRefs.length === 0) {
        console.log('[专业] 未找到组内专业');
        return;
      }

      // 提取组内专业列表，移除被拖拽的，再插入到新位置
      const majors = groupItemRefs.map(r => r.item);
      const [removed] = majors.splice(dragMajorIdx, 1);

      // 按拖动方向决定插入位置（不依赖鼠标在行内位置）：
      // - 从下往上拖（dragIdx > targetIdx）：插入到目标之前
      // - 从上往下拖（dragIdx < targetIdx）：插入到目标之后
      let insertAtGroupIdx;
      if (dragMajorIdx > targetMajorIdx) {
        // 从下往上拖：直接插到目标前面
        insertAtGroupIdx = targetMajorIdx;
      } else {
        // 从上往下拖：插到目标后面（移除拖拽项后目标索引已减1）
        insertAtGroupIdx = targetMajorIdx;
      }

      majors.splice(insertAtGroupIdx, 0, removed);

      // 重建 items 数组：用重排后的组替换原位置
      const newItems = [];
      const firstGroupIdx = groupItemRefs[0].idx;

      // 组前面的项
      for (let i = 0; i < firstGroupIdx; i++) {
        newItems.push(items[i]);
      }
      // 重排后的组内项
      majors.forEach(m => newItems.push(m));
      // 组后面的项
      const lastGroupRef = groupItemRefs[groupItemRefs.length - 1];
      for (let i = lastGroupRef.idx + 1; i < items.length; i++) {
        newItems.push(items[i]);
      }

      newItems.forEach((item, idx) => { item.order = idx + 1; });
      this.wishlistDetail.items = newItems;
      this.syncDetailOrderToWishList();
    },

    /** 在 wishlistDetail.items 中移动大组（整个学校）到新位置 */
    _reorderSchool(dragSchoolName, targetGroup) {
      const targetSchoolName = targetGroup.schoolName;
      if (dragSchoolName === targetSchoolName) {
        console.log('[大组] 同一学校，不移动', dragSchoolName);
        return;
      }

      const items = this.wishlistDetail.items;

      // 获取当前学校顺序（保留组的顺序，但按学校分组）
      const schoolKeys = [];
      const seen = new Set();
      const groupKeys = [];
      const groupSeen = new Set();
      items.forEach(item => {
        const gKey = this._getItemGroupKey(item);
        if (!groupSeen.has(gKey)) {
          groupSeen.add(gKey);
          groupKeys.push(gKey);
          const sKey = this._getItemSchoolKey(item);
          if (!seen.has(sKey)) {
            seen.add(sKey);
            schoolKeys.push(sKey);
          }
        }
      });

      const dragIdx = schoolKeys.indexOf(dragSchoolName);
      const targetIdx = schoolKeys.indexOf(targetSchoolName);
      if (dragIdx === -1 || targetIdx === -1) {
        console.log('[大组] 未找到索引', { dragSchoolName, targetSchoolName, dragIdx, targetIdx });
        return;
      }

      console.log('[大组] 原始学校顺序', schoolKeys);
      console.log('[大组] 拖拽/%s 索引=%d, 目标/%s 索引=%d', dragSchoolName, dragIdx, targetSchoolName, targetIdx);

      // 按拖动方向决定插入位置（不依赖鼠标在行内的位置）：
      // - 从下往上拖（dragIdx > targetIdx）：插到目标之前
      // - 从上往下拖（dragIdx < targetIdx）：插到目标之后
      schoolKeys.splice(dragIdx, 1);
      const newTargetIdx = schoolKeys.indexOf(targetSchoolName);
      const insertAfter = dragIdx < targetIdx; // 往下拖 → 插到目标之后
      const insertAt = insertAfter ? newTargetIdx + 1 : newTargetIdx;
      schoolKeys.splice(insertAt, 0, dragSchoolName);
      console.log('[大组] 新学校顺序', schoolKeys, { newTargetIdx, insertAfter, insertAt });

      // 按新学校顺序 + 原组内顺序重建 items
      const schoolGroupOrder = [];
      const sSeen = new Set();
      groupKeys.forEach(gk => {
        const sk = items.find(i => this._getItemGroupKey(i) === gk);
        const sKey = sk ? this._getItemSchoolKey(sk) : '';
        if (!sSeen.has(gk) && schoolKeys.includes(sKey)) {
          sSeen.add(gk);
          schoolGroupOrder.push(gk);
        }
      });

      // 按学校排序 -> 组排序
      const newItems = [];
      schoolKeys.forEach(sk => {
        schoolGroupOrder.forEach(gk => {
          if (gk.startsWith(sk + '_')) {
            items.forEach(item => {
              if (this._getItemGroupKey(item) === gk && !newItems.includes(item)) {
                newItems.push(item);
              }
            });
          }
        });
      });
      items.forEach(item => {
        if (!newItems.includes(item)) newItems.push(item);
      });

      newItems.forEach((item, idx) => { item.order = idx + 1; });
      this.wishlistDetail.items = newItems;
      this.syncDetailOrderToWishList();
    },

    /** 将 wishlistDetail.items 的排列顺序同步到主 wishList */
    syncDetailOrderToWishList() {
      if (!this.wishList.length || !this.wishlistDetail?.items?.length) return;

      const newOrder = [];
      const used = new Set();

      // 按新顺序匹配 wishList 中的项
      this.wishlistDetail.items.forEach(detailItem => {
        const sName = detailItem.school_name || '';
        const mName = detailItem.major_name || '';
        const mGroup = detailItem.major_group || '';

        for (let i = 0; i < this.wishList.length; i++) {
          if (used.has(i)) continue;
          const wItem = this.wishList[i];
          if ((wItem.school_name || '') === sName &&
              (wItem.major_name || '') === mName &&
              (wItem.major_group || '') === mGroup) {
            newOrder.push(wItem);
            used.add(i);
            break;
          }
        }
      });

      // 追加剩余项（理论上不会发生）
      this.wishList.forEach((item, i) => {
        if (!used.has(i)) newOrder.push(item);
      });

      this.wishList = newOrder;
      this.refreshDisplayWishData();
      this.$message.success('志愿表顺序已更新');
    },

    // 导出志愿表详情
    exportWishlistDetail() {
      if (!this.wishlistDetail || !this.wishlistDetail.items || this.wishlistDetail.items.length === 0) {
        this.$message.warning('没有数据可导出');
        return;
      }
      
      // 将数据映射为导出格式，保留原始顺序不变
      const exportRows = this.wishlistDetail.items.map(item => {
        return {
          '序号': item.order ?? '-',
          '学校名称': item.school_name || item.学校名称 || '-',
          '专业名称': item.major_name || item.专业名称 || '-',
          '专业组': item.major_group || item.专业组 || '-',
          '最低分': item.l_scr || item.最低分 || '-',
          '最低位次': item.l_rnk || item.最低位次 || '-',
          '冲稳保': item.risk || item.冲稳保 || '-'
        };
      });
      
      // 使用学生信息生成文件名
      const studentName = this.wishlistDetail.student_info?.student_name || '未知';
      const fileName = `志愿表详情-${this.wishlistDetail.name || studentName}`;
      
      this.exportData(exportRows, fileName, fileName, '导出志愿表详情成功');
    },

    // 导出志愿表详情为图片
    async exportWishlistImage() {
      if (!this.wishlistDetail || !this.wishlistDetail.items || this.wishlistDetail.items.length === 0) {
        this.$message.warning('没有数据可导出');
        return;
      }
      try {
        const html2canvas = (await import('html2canvas')).default;
        const contentEl = this.$refs.wishlistDetailBody;
        if (!contentEl) {
          this.$message.error('未找到内容区域');
          return;
        }
        // 克隆并展开 rowspan（第一行保留内容，后续行只保留背景不显示文字）
        const clone = contentEl.cloneNode(true);
        this._expandRowspan(clone);
        // 导出时移除删除按钮
        clone.querySelectorAll('.no-export').forEach(el => el.remove());

        // 与 PDF 导出一样，去掉第一列（复选框列）
        const cloneThead = clone.querySelector('thead');
        if (cloneThead) {
          const firstTh = cloneThead.querySelector('tr')?.querySelector('th');
          if (firstTh) firstTh.remove();
        }
        const cloneTbody = clone.querySelector('tbody');
        if (cloneTbody) {
          cloneTbody.querySelectorAll('tr').forEach(row => {
            const firstTd = row.querySelector('td');
            if (firstTd) firstTd.remove();
          });
        }

        // 与 PDF 导出一样，调整大组前两列边框线（去掉内部横线，大组之间保留横线）
        if (cloneTbody) {
          const imgRows = Array.from(cloneTbody.querySelectorAll('tr'));
          let currentGroupKey = null;
          let groupRows = [];
          for (const row of imgRows) {
            const gKey = row.getAttribute('data-group-key');
            if (!gKey) continue;
            if (gKey !== currentGroupKey) {
              if (groupRows.length > 0) {
                for (let i = 0; i < groupRows.length; i++) {
                  const cells = groupRows[i].querySelectorAll('td');
                  for (let c = 0; c < Math.min(2, cells.length); c++) {
                    if (i < groupRows.length - 1) cells[c].style.borderBottom = 'none';
                    if (i > 0) cells[c].style.borderTop = 'none';
                  }
                }
              }
              currentGroupKey = gKey;
              groupRows = [row];
            } else {
              groupRows.push(row);
            }
          }
          if (groupRows.length > 0) {
            for (let i = 0; i < groupRows.length; i++) {
              const cells = groupRows[i].querySelectorAll('td');
              for (let c = 0; c < Math.min(2, cells.length); c++) {
                if (i < groupRows.length - 1) cells[c].style.borderBottom = 'none';
                if (i > 0) cells[c].style.borderTop = 'none';
              }
            }
          }
        }

        clone.style.position = 'absolute';
        clone.style.left = '0';
        clone.style.top = '0';
        clone.style.width = contentEl.offsetWidth + 'px';
        clone.style.background = '#ffffff';
        document.body.appendChild(clone);

        const canvas = await html2canvas(clone, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
          logging: false,
        });
        document.body.removeChild(clone);

        // 下载图片
        const link = document.createElement('a');
        const studentName = this.wishlistDetail.student_info?.student_name || '未知';
        link.download = `志愿表详情-${this.wishlistDetail.name || studentName}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
        this.$message.success('图片导出成功');
      } catch (err) {
        console.error('导出图片失败:', err);
        this.$message.error('导出图片失败: ' + (err.message || '未知错误'));
      }
    },

    // 导出志愿表详情为 PDF
    async exportWishlistPDF() {
      if (!this.wishlistDetail || !this.wishlistDetail.items || this.wishlistDetail.items.length === 0) {
        this.$message.warning('没有数据可导出');
        return;
      }
      try {
        const [html2canvas, { default: jsPDF }] = await Promise.all([
          import('html2canvas'),
          import('jspdf'),
        ]);
        const contentEl = this.$refs.wishlistDetailBody;
        if (!contentEl) {
          this.$message.error('未找到内容区域');
          return;
        }
        // 克隆并展开 rowspan
        const clone = contentEl.cloneNode(true);
        this._expandRowspan(clone);
        // 导出时移除删除按钮
        clone.querySelectorAll('.no-export').forEach(el => el.remove());

        // 导出 PDF 时去掉第一列（复选框列）
        const cloneThead = clone.querySelector('thead');
        if (cloneThead) {
          const firstTh = cloneThead.querySelector('tr')?.querySelector('th');
          if (firstTh) firstTh.remove();
        }
        const cloneTbody = clone.querySelector('tbody');
        if (cloneTbody) {
          cloneTbody.querySelectorAll('tr').forEach(row => {
            const firstTd = row.querySelector('td');
            if (firstTd) firstTd.remove();
          });
        }

        // PDF 导出样式：大组前两列只保留竖线，去掉内部横线，大组之间保留横线
        const pdfTbody = cloneTbody;
        if (pdfTbody) {
          const pdfRows = Array.from(pdfTbody.querySelectorAll('tr'));
          let currentGroupKey = null;
          let groupRows = [];
          for (const row of pdfRows) {
            const gKey = row.getAttribute('data-group-key');
            if (!gKey) continue;
            if (gKey !== currentGroupKey) {
              // 处理前一个大组
              if (groupRows.length > 0) {
                for (let i = 0; i < groupRows.length; i++) {
                  const cells = groupRows[i].querySelectorAll('td');
                  for (let c = 0; c < Math.min(2, cells.length); c++) {
                    if (i < groupRows.length - 1) cells[c].style.borderBottom = 'none';
                    if (i > 0) cells[c].style.borderTop = 'none';
                  }
                }
              }
              currentGroupKey = gKey;
              groupRows = [row];
            } else {
              groupRows.push(row);
            }
          }
          // 处理最后一个大组
          if (groupRows.length > 0) {
            for (let i = 0; i < groupRows.length; i++) {
              const cells = groupRows[i].querySelectorAll('td');
              for (let c = 0; c < Math.min(2, cells.length); c++) {
                if (i < groupRows.length - 1) cells[c].style.borderBottom = 'none';
                if (i > 0) cells[c].style.borderTop = 'none';
              }
            }
          }
        }

        // 注意：此处不改动 DOM 边框，避免影响后续 getBoundingClientRect 的测量值

        clone.style.position = 'absolute';
        clone.style.left = '0';
        clone.style.top = '0';
        clone.style.width = contentEl.offsetWidth + 'px';
        clone.style.background = '#ffffff';
        document.body.appendChild(clone);

        // 测量每个大组在 DOM 中的 Y 轴边界
        // _expandRowspan 已移除 rowspan，每组由 N 行组成，
        // 以 firstRect.top（首行顶部）~ lastRect.bottom（末行底部）作为整组边界
        void clone.offsetHeight;
        const cloneRect = clone.getBoundingClientRect();
        const groupBoundaries = [];
        const allRows = clone.querySelectorAll('tr');
        const groupRowMap = new Map();
        allRows.forEach(row => {
          const gKey = row.getAttribute('data-group-key');
          if (!gKey) return;
          let entry = groupRowMap.get(gKey);
          if (!entry) {
            entry = { first: row, last: row };
            groupRowMap.set(gKey, entry);
          } else {
            entry.last = row;
          }
        });
        groupRowMap.forEach((entry, key) => {
          const firstRect = entry.first.getBoundingClientRect();
          const lastRect = entry.last.getBoundingClientRect();
          groupBoundaries.push({
            key: key,
            startY: firstRect.top - cloneRect.top,
            endY: lastRect.bottom - cloneRect.top,
          });
        });
        groupBoundaries.sort((a, b) => a.startY - b.startY);

        const canvas = await html2canvas.default(clone, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
        });
        const cloneWidth = clone.offsetWidth;
        document.body.removeChild(clone);

        // 将 DOM 坐标换算为 canvas 坐标（考虑 scale）
        const canvasScale = canvas.width / cloneWidth;
        groupBoundaries.forEach(gb => {
          gb.startY = gb.startY * canvasScale;
          gb.endY = gb.endY * canvasScale;
        });

        // 边距设置
        const marginMode = this.pdfMarginMode || 'normal';
        let marginTop = 10, marginBottom = 10, marginLeft = 10, marginRight = 10;
        if (marginMode === 'normal') {
          marginTop = 25.4; marginBottom = 25.4; marginLeft = 31.7; marginRight = 31.7;
        } else if (marginMode === 'narrow') {
          marginTop = 12.7; marginBottom = 12.7; marginLeft = 12.7; marginRight = 12.7;
        } else if (marginMode === 'custom') {
          marginTop = 25.4; marginBottom = 25.4; marginLeft = 15; marginRight = 15;
        }

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();
        const pdfContentW = pageW - marginLeft - marginRight;
        const pdfContentH = pageH - marginTop - marginBottom;
        const ratio = pdfContentW / canvas.width;
        const pageCanvasH = pdfContentH / ratio;

        // 分页：把大组作为最小不可分割单元；先从固定高度切割页入手，
        // 然后确保每页只包含"起始位置 <= 页起点"或"完全在前一页之前结束"的大组
        let srcY = 0;
        let pageIndex = 0;
        while (srcY < canvas.height) {
          // 本页的硬性最大结束位置
          const hardEnd = Math.min(srcY + pageCanvasH, canvas.height);

          // 找到"可整组放入当前页"的最后大组边界
          let breakY = srcY;
          for (const gb of groupBoundaries) {
            if (gb.startY <= srcY) continue;             // 已渲染
            if (gb.startY > hardEnd) break;              // 大组起点在页外，停止
            if (gb.endY <= hardEnd) {
              // 该大组可完整放入当前页
              breakY = gb.endY;
            } else {
              // 该大组超出当前页容量：分页点 = 该大组起点（让该组完整放下一页）
              breakY = gb.startY;
              break;
            }
          }
          if (breakY <= srcY) {
            // 当前页无法容纳任何完整大组（可能第一个大组本身就 > pageCanvasH）
            // 强制推进到第一个大组末尾（即便会切到该大组）
            const next = groupBoundaries.find(gb => gb.startY >= srcY);
            breakY = next ? Math.min(next.endY, hardEnd) : hardEnd;
          }
          const cropH = Math.max(Math.min(breakY - srcY, canvas.height - srcY), 1);
          if (cropH <= 0) break;

          // 裁剪并加入 PDF
          const tempCanvas = document.createElement('canvas');
          tempCanvas.width = canvas.width;
          tempCanvas.height = cropH;
          const ctx = tempCanvas.getContext('2d');
          ctx.drawImage(canvas, 0, srcY, canvas.width, cropH, 0, 0, canvas.width, cropH);

          // 先无条件擦除底部 2px 为白色，去掉表格自身 `border: 1px solid #333` 的底部边框线
          // 后续分页线（fillRect）会覆盖这 2px 白条，因此非末页不受影响
          // 末页没有分页线，白条保留从而隐藏表格底部边框
          if (tempCanvas.height > 2) {
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, tempCanvas.height - 2, tempCanvas.width, 2);
          }

          // 分页处添加边框线，厚度 4px（html2canvas scale=2 下对应 2px CSS）
          // 顶部线只在"非首页且非末页"画，底部线只在"非末页"画
          const hasNextPage = srcY + cropH + 0.5 < canvas.height;
          ctx.fillStyle = '#333';
          if (pageIndex > 0 && hasNextPage) {
            ctx.fillRect(0, 0, tempCanvas.width, 4);
          }
          if (hasNextPage) {
            ctx.fillRect(0, tempCanvas.height - 4, tempCanvas.width, 4);
          }

          const pageImgData = tempCanvas.toDataURL('image/jpeg', 0.95);
          if (pageIndex > 0) pdf.addPage();
          pdf.addImage(pageImgData, 'JPEG', marginLeft, marginTop, pdfContentW, cropH * ratio);
          srcY += cropH;
          pageIndex++;
        }

        const fileName = `志愿表详情-${this.wishlistDetail.name || this.wishlistDetail.student_info?.student_name || '未知'}.pdf`;
        pdf.save(fileName);
        this.$message.success('PDF导出成功');
      } catch (err) {
        console.error('导出PDF失败:', err);
        this.$message.error('导出PDF失败: ' + (err.message || '未知错误'));
      }
    },

    /** 展开克隆节点中的所有 rowspan：第一行保留内容，后续行仅有空单元格（保持背景色），避免 html2canvas 遗漏且不重复显示数据 */
    _expandRowspan(container) {
      if (!container) return;
      const rows = container.querySelectorAll('tr');
      for (let r = 0; r < rows.length; r++) {
        const cells = Array.from(rows[r].cells);
        for (let c = 0; c < cells.length; c++) {
          const cell = cells[c];
          const rowspanStr = cell.getAttribute('rowspan');
          if (rowspanStr && parseInt(rowspanStr) > 1) {
            const span = parseInt(rowspanStr);
            const style = cell.getAttribute('style') || '';
            const cls = cell.getAttribute('class') || '';
            cell.removeAttribute('rowspan');
            // 后续行：创建空单元格，只保留样式/背景，不显示文字
            for (let s = 1; s < span; s++) {
              if (r + s < rows.length) {
                const newCell = document.createElement('td');
                newCell.innerHTML = '&nbsp;';
                if (style) newCell.setAttribute('style', style);
                if (cls) newCell.setAttribute('class', cls);
                const targetCells = rows[r + s].cells;
                if (c < targetCells.length) {
                  targetCells[c].parentNode.insertBefore(newCell, targetCells[c]);
                } else {
                  rows[r + s].appendChild(newCell);
                }
              }
            }
          }
        }
      }
    },

    // 加载志愿表到当前志愿表
    async loadWishlistToTable(wishlistId) {
      try {
        const response = await axios.get(`api/wishlist/${wishlistId}/`, {
          withCredentials: true
        });
        
        if (response.data.success) {
          const data = response.data.data;
          if (data.items && data.items.length > 0) {
            // 确认是否覆盖当前志愿表
            if (this.wishList.length > 0) {
              const confirmed = confirm('当前志愿表有数据，是否覆盖？');
              if (!confirmed) return;
            }
            
            // 加载志愿表数据（后端已按配置排序并合并extra_data，直接展开即可）
            this.wishList = data.items.map(item => ({...item}));
            // 初始化志愿表显示数据（与筛选表 displayFilteredData 模式一致）
            this.refreshDisplayWishData();
            
            // 用 student_info 更新学生信息表单（只更新有效值，null 不清空现有值）
            if (data.student_info) {
              this.formData.student_name = data.student_info.student_name || this.formData.student_name;
              this.formData.gender = data.student_info.gender || this.formData.gender;
              this.formData.origin = data.student_info.origin || this.formData.origin;
              this.formData.admit_year = data.student_info.admit_year || this.formData.admit_year;
              this.formData.batch = data.student_info.batch || this.formData.batch;
              
              // 数值字段用 != null 判断，避免 null 覆盖有效值（0 是有效分数）
              if (data.student_info.score != null) {
                this.formData.scr_line = data.student_info.score;
              }
              if (data.student_info.admission_rank != null) {
                this.formData.admission_rank = data.student_info.admission_rank;
              }
              if (data.student_info.rush_rank != null) {
                this.formData.rush_rank = data.student_info.rush_rank;
              }
              if (data.student_info.stable_rank != null) {
                this.formData.stable_rank = data.student_info.stable_rank;
              }
              if (data.student_info.safe_rank != null) {
                this.formData.safe_rank = data.student_info.safe_rank;
              }
              
              // 拆分科目（后端保存为 subject1+subject2+subject3）
              if (data.student_info.subject) {
                const parts = data.student_info.subject.split('+');
                if (parts.length >= 3) {
                  this.formData.subject1 = parts[0];
                  this.formData.subject2 = parts[1];
                  this.formData.subject3 = parts[2];
                }
              }
              
              // 保存到 localStorage，保持与手动输入时一致
              localStorage.setItem('student_name', this.formData.student_name || '');
              localStorage.setItem('student_gender', this.formData.gender || '');
              localStorage.setItem('student_origin', this.formData.origin || '');
              localStorage.setItem('student_score', this.formData.scr_line || '');
              localStorage.setItem('student_rank', this.formData.admission_rank || '');
              localStorage.setItem('student_batch', this.formData.batch || '');
              localStorage.setItem('student_subject1', this.formData.subject1 || '');
              localStorage.setItem('student_subject2', this.formData.subject2 || '');
              localStorage.setItem('student_subject3', this.formData.subject3 || '');
            }
            
            this.$message.success(`已加载 ${data.items.length} 个志愿`);
            this.closeWishlistHistoryDialog();
          } else {
            this.$message.warning('该志愿表没有数据');
          }
        } else {
          this.$message.error(response.data.message || '加载失败');
        }
      } catch (error) {
        console.error('加载志愿表失败:', error);
        this.$message.error('加载志愿表失败');
      }
    },
    
    // 删除志愿表
    async deleteWishlist(wishlistId) {
      const confirmed = confirm('确定要删除这条志愿表记录吗？');
      if (!confirmed) return;
      
      try {
        const response = await axios.delete(`api/wishlist/${wishlistId}/delete/`, {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.$message.success('删除成功');
          await this.loadWishlistHistory();
        } else {
          this.$message.error(response.data.message || '删除失败');
        }
      } catch (error) {
        console.error('删除志愿表失败:', error);
        this.$message.error('删除失败');
      }
    },
    
    // ===== 志愿表分享功能 =====
    
    // 切换选项卡
    async switchWishlistTab(tab) {
      this.wishlistTab = tab;
      if (tab === 'shared-to-me' && !this.sharedWishlistsLoaded) {
        await this.loadSharedWishlists();
      }
    },
    
    // 打开分享对话框
    openShareDialog(item) {
      this.showShareDialog = true;
      this.shareTargetWishlist = item;
      this.shareTargetPhone = '';
      this.sharePermission = 'view';
      this.shareErrorMessage = '';
    },
    
    // 关闭分享对话框
    closeShareDialog() {
      this.showShareDialog = false;
      this.shareTargetWishlist = null;
    },
    
    // 确认分享
    async confirmShare() {
      const phone = this.shareTargetPhone.trim();
      if (!phone) {
        this.shareErrorMessage = '请输入被分享者的手机号';
        return;
      }
      if (!/^1\d{10}$/.test(phone)) {
        this.shareErrorMessage = '请输入正确的手机号（11位）';
        return;
      }
      
      this.isSharing = true;
      this.shareErrorMessage = '';
      
      try {
        const response = await axios.post('api/wishlist/share/', {
          wishlist_id: this.shareTargetWishlist.id,
          target_phone: phone,
          permission: this.sharePermission
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken'
        });
        
        if (response.data.success) {
          this.$message.success(response.data.message || '分享成功');
          this.closeShareDialog();
        } else {
          this.shareErrorMessage = response.data.message || '分享失败';
        }
      } catch (error) {
        console.error('分享失败:', error);
        // 优先显示后端返回的具体错误信息
        if (error.response?.data?.message) {
          this.shareErrorMessage = error.response.data.message;
        } else if (error.response?.data?.detail) {
          this.shareErrorMessage = error.response.data.detail;
        } else if (error.response?.data) {
          // 尝试显示原始响应体（可能是HTML错误页）
          const rawData = typeof error.response.data === 'string' ? error.response.data.substring(0, 200) : JSON.stringify(error.response.data);
          this.shareErrorMessage = `服务器异常: ${error.response.status} - ${rawData}`;
        } else if (error.message) {
          this.shareErrorMessage = `网络错误: ${error.message}`;
        } else {
          this.shareErrorMessage = '分享失败，请稍后重试';
        }
      } finally {
        this.isSharing = false;
      }
    },
    
    // 加载分享给我的记录
    async loadSharedWishlists() {
      this.sharedWishlistsLoaded = false;
      try {
        const response = await axios.get('api/wishlist/shared-to-me/', {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.sharedWishlists = response.data.data || [];
        } else {
          console.error('加载分享记录失败:', response.data.message);
        }
      } catch (error) {
        console.error('加载分享记录失败:', error);
        if (error.response?.status !== 403) {
          this.$message.error('加载分享记录失败');
        }
      } finally {
        this.sharedWishlistsLoaded = true;
      }
    },
    
    // 加载分享给我的志愿表到当前表格
    async loadSharedWishlistToTable(wishlistId) {
      try {
        const response = await axios.get(`api/wishlist/${wishlistId}/`, {
          withCredentials: true
        });
        
        if (response.data.success) {
          const data = response.data.data;
          if (!data.is_owner && data.share_permission !== 'edit') {
            this.$message.warning('您只有查看权限，无法加载编辑');
            return;
          }
          
          if (data.items && data.items.length > 0) {
            if (this.wishList.length > 0) {
              const confirmed = confirm('当前志愿表有数据，是否覆盖？');
              if (!confirmed) return;
            }
            
            const columnOrder = this.filteredData && this.filteredData.length > 0 
              ? Object.keys(this.filteredData[0]) 
              : [];
            
            this.wishList = data.items.map(item => {
              if (columnOrder.length > 0) {
                const orderedData = {};
                columnOrder.forEach(key => {
                  if (key in item) {
                    orderedData[key] = item[key];
                  }
                });
                Object.keys(item).forEach(key => {
                  if (!(key in orderedData)) {
                    orderedData[key] = item[key];
                  }
                });
                return orderedData;
              }
              return {...item};
            });
            // 初始化志愿表显示数据（与筛选表 displayFilteredData 模式一致）
            this.refreshDisplayWishData();
            
            this.$message.success(`已加载 ${data.items.length} 个志愿（来自分享）`);
            this.closeWishlistHistoryDialog();
          } else {
            this.$message.warning('该志愿表没有数据');
          }
        } else {
          this.$message.error(response.data.message || '加载失败');
        }
      } catch (error) {
        console.error('加载分享的志愿表失败:', error);
        this.$message.error('加载失败');
      }
    },
    
    // 选择招生计划备注项（用于多行展开模式的复选框）- 支持多选
    selectPlanRemarkItem(record, item) {
      // 确保有选中项数组
      if (!record.selected_plan_items) {
        this.$set(record, 'selected_plan_items', []);
      }
      
      // 检查该项是否已选中
      const itemIndex = record.selected_plan_items.findIndex(selected => 
        selected.admit_year === item.admit_year && 
        selected.batch === item.batch && 
        selected.remark === item.remark
      );
      
      if (itemIndex > -1) {
        // 已选中则取消选择
        record.selected_plan_items.splice(itemIndex, 1);
        // 如果没有选中的项了，取消确认状态
        if (record.selected_plan_items.length === 0) {
          this.$set(record, 'is_confirmed', false);
        }
      } else {
        // 未选中则添加到选中列表
        record.selected_plan_items.push(item);
        this.$set(record, 'is_confirmed', true);
      }
      
      // 兼容旧逻辑，保留第一个选中项到 selected_plan_item
      if (record.selected_plan_items.length > 0) {
        this.$set(record, 'selected_plan_item', record.selected_plan_items[0]);
        this.$set(record, 'selected_plan_remark', record.selected_plan_items[0].remark || '');
      } else {
        this.$set(record, 'selected_plan_item', null);
        this.$set(record, 'selected_plan_remark', '');
      }
    },

    // ========== 位次趋势折线图相关方法 ==========
    // 解析趋势数据（可能是 JSON 字符串）
    parseTrendData(trendData) {
      if (typeof trendData === 'string') {
        try {
          return JSON.parse(trendData);
        } catch (e) {
          return [];
        }
      }
      return trendData || [];
    },

    // 获取趋势线路径（SVG polyline points）
    getTrendLinePath(trendData, field) {
      const cfg = this.getTrendChartConfig(trendData, field);
      if (!cfg || !cfg.points || cfg.points.length === 0) return '';
      return cfg.points.map(p => `${p.x},${p.y}`).join(' ');
    },

    // 获取趋势数据点坐标
    getTrendDots(trendData, field) {
      const cfg = this.getTrendChartConfig(trendData, field);
      if (!cfg || !cfg.points) return [];
      return cfg.points;
    },

    // 计算图表布局参数（l_rnk 和 h_rnk 共用统一 Y 轴范围）
    getTrendChartConfig(trendData, field) {
      const data = this.parseTrendData(trendData);
      if (data.length === 0) return null;

      const W = 200, H = 50;
      const padX = 14, padY = 8;
      const chartW = W - padX * 2;
      const chartH = H - padY * 2;

      // 统一收集所有有效位次值（l_rnk 和 h_rnk 合并），确保共用同一 Y 轴
      let allRanks = [];
      data.forEach(d => { if (d['l_rnk'] != null) allRanks.push(d['l_rnk']); if (d['h_rnk'] != null) allRanks.push(d['h_rnk']); });

      if (allRanks.length === 0) return null;

      const minR = Math.min(...allRanks);
      const maxR = Math.max(...allRanks);
      const range = maxR - minR || 1;

      // 按 field 过滤并计算坐标
      const entries = [];
      data.forEach((d, i) => {
        if (d[field] != null) {
          entries.push({
            x: padX + (i / Math.max(data.length - 1, 1)) * chartW,
            y: padY + ((d[field] - minR) / range) * chartH,
            year: d.year,
            rank: d[field]
          });
        }
      });

      if (entries.length === 0) return null;
      return { points: entries };
    },

    // 计算用户位次在趋势图中的 Y 坐标
    getUserRankY(trendData) {
      const data = this.parseTrendData(trendData);
      if (data.length === 0 || !this.formData.admission_rank) return -100; // 不可见
      const myRank = Number(this.formData.admission_rank);
      // 共用 getTrendChartConfig 的统一 Y 轴范围
      const cfg = this.getTrendChartConfig(trendData, 'l_rnk');
      if (!cfg || !cfg.points || cfg.points.length === 0) return -100;
      // 从 cfg 中推回 minR/maxR
      let allRanks = [];
      data.forEach(d => { if (d['l_rnk'] != null) allRanks.push(d['l_rnk']); if (d['h_rnk'] != null) allRanks.push(d['h_rnk']); });
      if (allRanks.length === 0) return -100;
      const minR = Math.min(...allRanks);
      const maxR = Math.max(...allRanks);
      const range = maxR - minR || 1;
      const padY = 8, chartH = 34;
      if (myRank < minR) return padY - 5;
      if (myRank > maxR) return padY + chartH + 5;
      return padY + ((myRank - minR) / range) * chartH;
    },

    // 招生数折线图：计算 polyline points
    getEnrollmentLinePath(trendData, field) {
      const cfg = this.getEnrollmentChartConfig(trendData, field);
      if (!cfg || !cfg.points || cfg.points.length === 0) return '';
      return cfg.points.map(p => `${p.x},${p.y}`).join(' ');
    },

    // 招生数折线图：获取数据点
    getEnrollmentDots(trendData, field) {
      const cfg = this.getEnrollmentChartConfig(trendData, field);
      if (!cfg || !cfg.points) return [];
      return cfg.points;
    },

    // 招生数图表布局参数
    getEnrollmentChartConfig(trendData, field) {
      const data = this.parseTrendData(trendData);
      if (data.length === 0) return null;

      const W = 200, H = 50;
      const padX = 14, padY = 8;
      const chartW = W - padX * 2;
      const chartH = H - padY * 2;

      // 统一 Y 轴：合并 plan 和 pre_pl 的所有值
      let allVals = [];
      data.forEach(d => {
        if (d['plan'] != null) allVals.push(d['plan']);
        if (d['pre_pl'] != null) allVals.push(d['pre_pl']);
      });
      if (allVals.length === 0) return null;
      const minV = Math.min(...allVals);
      const maxV = Math.max(...allVals);
      const range = maxV - minV || 1;

      const entries = [];
      data.forEach((d, i) => {
        if (d[field] != null) {
          entries.push({
            x: padX + (i / Math.max(data.length - 1, 1)) * chartW,
            y: padY + chartH - ((d[field] - minV) / range) * chartH,
            year: d.year,
            val: d[field]
          });
        }
      });
      if (entries.length === 0) return null;
      return { points: entries };
    },

    // ========== 志愿表详情弹窗缺失的方法 ==========

    /** 判断当前专业是否为组内最后一个非占位符 */
    isLastNonPlaceholder(mIdx, majors) {
      if (!majors || !Array.isArray(majors)) return false;
      for (let i = majors.length - 1; i >= 0; i--) {
        if (!majors[i].isPlaceholder) {
          return i === mIdx;
        }
      }
      return false;
    },

    /** 获取专业组实际最低分 */
    getGroupActualMinScore(group) {
      if (!group || !group.majors) return '';
      const realMajors = group.majors.filter(m => !m.isPlaceholder);
      if (realMajors.length === 0) return '';
      // 优先从该组第一个专业对应 item 的 group_actual_min_score 获取（后端已计算）
      if (this.wishlistDetail && this.wishlistDetail.items) {
        const groupItems = this.wishlistDetail.items.filter(item => {
          const sName = item.school_name || item.学校名称 || '';
          const mGroup = item.major_group || item.专业组 || '';
          return `${sName}_${mGroup}` === group.key && item.group_actual_min_score != null;
        });
        if (groupItems.length > 0) return groupItems[0].group_actual_min_score;
      }
      // 回退：从 majors 中取最小值
      const scores = realMajors
        .map(m => Number(m.score))
        .filter(s => !isNaN(s) && s > 0);
      return scores.length > 0 ? Math.min(...scores) : (group.score || '');
    },

    /** 获取专业组实际最低位次 */
    getGroupActualMinRank(group) {
      if (!group || !group.majors) return '';
      if (this.wishlistDetail && this.wishlistDetail.items) {
        const groupItems = this.wishlistDetail.items.filter(item => {
          const sName = item.school_name || item.学校名称 || '';
          const mGroup = item.major_group || item.专业组 || '';
          return `${sName}_${mGroup}` === group.key && item.group_actual_min_rank != null && item.group_actual_min_rank !== '';
        });
        if (groupItems.length > 0) {
          const raw = groupItems[0].group_actual_min_rank;
          const cleaned = String(raw).replace(/[^\d]/g, '').trim();
          const num = Number(cleaned);
          if (!isNaN(num) && isFinite(num) && num > 0) {
            return num;
          }
        }
      }
      const realMajors = group.majors.filter(m => !m.isPlaceholder);
      const ranks = realMajors
        .map(m => Number(m.rank))
        .filter(r => !isNaN(r) && r > 0);
      return ranks.length > 0 ? Math.min(...ranks) : (group.rank || '');
    },

    /** 计算专业组最低位次与考生位次的差值（最低位次-用户位次，正值有优势） */
    getGroupActualMinRankDiff(group) {
      const minRank = this.getGroupActualMinRank(group);
      const studentRank = this.formData?.admission_rank;
      if (!minRank || minRank === '' || !studentRank) return null;
      return Number(minRank) - Number(studentRank);
    },

    /** 格式化计划数差值 */
    formatPlanDiff(diff) {
      if (diff == null || diff === '') return '';
      const num = Number(diff);
      if (isNaN(num)) return '';
      return num > 0 ? `扩招+${num}` : num < 0 ? `缩招${num}` : '持平';
    },

    /** 切换删除/恢复所有占位空行 */
    toggleAllEmpties() {
      const isUncheck = this.wishDetailRemovedEmpties.length > 0;

      if (isUncheck) {
        // 当前已删除空行 → 恢复全部，滚动到底部
        this.wishDetailRemovedEmpties = [];
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const el = this.$refs.wishlistDetailModal;
            if (el) el.scrollTop = el.scrollHeight;
          });
        });
      } else {
        // 当前未删除空行 → 删除全部（收集所有组key）
        const allKeys = this.wishlistDetailGrouped.map(g => g.key);
        this.wishDetailRemovedEmpties = allKeys;
      }
    },

    /** 删除整个大组（院校专业组） */
    deleteWishDetailGroup(group) {
      const groupKey = group.key;
      const groupItems = this.wishlistDetail.items.filter(item => this._getItemGroupKey(item) === groupKey);
      if (groupItems.length === 0) return;
      const label = group.schoolName + (group.majorGroup || '');
      this.$confirm(
        `确定要删除「${label}」这个院校专业组（共 ${groupItems.length} 条志愿）吗？删除后可通过重新导入恢复。`,
        '确认删除大组',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        const newItems = this.wishlistDetail.items.filter(item => this._getItemGroupKey(item) !== groupKey);
        this._updateWishDetailItems(newItems);
        this.$message.success(`已删除大组「${label}」`);
      }).catch(() => {});
    },

    /** 删除单条专业 */
    deleteWishDetailMajor(group, major, mIdx) {
      if (major.isPlaceholder) return;
      // 找到该组中所有原始 item，按 order 排序后取第 mIdx 个
      const realItems = this.wishlistDetail.items.filter(item => this._getItemGroupKey(item) === group.key);
      const sortedRealItems = [...realItems].sort((a, b) => (a.order || 0) - (b.order || 0));
      if (mIdx >= sortedRealItems.length) return;
      const itemToRemove = sortedRealItems[mIdx];
      const label = major.majorName || `第${mIdx+1}条`;
      this.$confirm(
        `确定要删除「${label}」这条志愿吗？`,
        '确认删除',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        const newItems = this.wishlistDetail.items.filter(item => item !== itemToRemove);
        this._updateWishDetailItems(newItems);
        this.$message.success(`已删除「${label}」`);
      }).catch(() => {});
    },

    /** 更新志愿表详情 items（重新编号 + 同步主表 + 清理选中） */
    _updateWishDetailItems(newItems) {
      newItems.forEach((item, idx) => { item.order = idx + 1; });
      this.$set(this.wishlistDetail, 'items', newItems);
      this.wishDetailSelectedGroups = [];
      this.syncDetailOrderToWishList();
    },

  },
  watch: {
    // 监听formData中相关字段的变化，保存到localStorage
    'formData.origin': function(newVal) {
      localStorage.setItem('student_origin', newVal);
    },
    'formData.student_name': function(newVal) {
      localStorage.setItem('student_name', newVal);
    },
    'formData.gender': function(newVal) {
      localStorage.setItem('student_gender', newVal);
    },
    'formData.batch': function(newVal) {
      localStorage.setItem('student_batch', newVal);
      // 填报类型变化时，先清空招生类型，让 fetchEnrollmentTypes 设置默认值
      this.formData.enrollment_type = '';
      // 批次变化时重新获取招生类型
      this.fetchEnrollmentTypes();
    },
    'formData.enrollment_type': function(newVal) {
      localStorage.setItem('student_enrollment_type', newVal);
    },
    'formData.scr_line': {
      handler: function(newVal) {
        localStorage.setItem('student_score', newVal);
      },
      deep: true
    },
    'formData.admission_rank': function(newVal) {
      localStorage.setItem('student_rank', newVal);
    },
    'formData.same_rank_score': function(newVal) {
      localStorage.setItem('same_rank_score', newVal);
    },
    'formData.subject1': function(newVal) {
      localStorage.setItem('student_subject1', newVal);
    },
    'formData.subject2': function(newVal) {
      localStorage.setItem('student_subject2', newVal);
    },
    'formData.subject3': function(newVal) {
      localStorage.setItem('student_subject3', newVal);
    },
    // 监听专业筛选条件变化，保存到localStorage
    professionalRows: {
      handler(newVal) {
        localStorage.setItem('professionalRows', JSON.stringify(newVal));
      },
      deep: true
    },
    // 监听搜索目标表格变化，重置搜索索引
    searchTargetTable() {
      this.currentSearchIndex = -1;
    },

    // 监听wishList变化，重新应用表头样式、清空缓存、刷新显示数据
    wishList: {
      handler() {
        this.wishColumnUniqueCache = {};
        this.refreshDisplayWishData();
        this.$nextTick(() => {
          clearTimeout(this.styleTimeout);
          this.styleTimeout = setTimeout(() => {
            this.setHeaderStyles();
            setTimeout(() => {
              this.applyColumnWidths();
            }, 50);
          }, 100);
        });
      },
      deep: false
    },
    // 监听filteredData变化，重新应用表头样式、清空缓存、刷新显示数据
    filteredData: {
      handler() {
        this.columnUniqueCache = {};
        this.refreshDisplayFilteredData();
        this.$nextTick(() => {
          // 避免重复调用，使用防抖
          clearTimeout(this.styleTimeout);
          this.styleTimeout = setTimeout(() => {
            this.setHeaderStyles();
            // 延迟应用列宽，避免与渲染竞争
            setTimeout(() => {
              this.applyColumnWidths();
            }, 50);
          }, 100);
        });
      },
      // 移除 deep 监听，使用浅监听减少开销
      deep: false
    }
  }
}



